<template>
    <div
        class="content full hide-scrollbar"
        :class="[
            $mq,
            {
                'landscape-tablet': ['landscape', 'desktop'].includes($mq) && (OS() == 'Android' || OS() == 'iOS')
            },
            { condensed: onFocus }
        ]"
        :key="selectedState.id"
    >
        <template v-if="fullPreview">
            <div class="full-preview" @click="maximizePreview()">
                <div class="close-preview" @click="maximizePreview()"></div>
                <div ref="fullPreviewContent" class="full-preview-content" :class="{ 'full-preview-content--normal': !isAZplValid }">
                    <Preview v-if="!isAZplValid" :refresh="!scanningQR" :data="newPreviewData" :maximized="true"></Preview>
                    <ZplPreview
                      v-else
                      :data="zpl"
                      :density="density"
                      :width="labelWidth"
                      :height="labelHeight"
                      :values="zplValues"
                      :params="zplParams"
                      :showControls="false"
                      :fitToContainer="true"
                      :previewScale="2"
                      :scale="1"
                      :key="zplKey"
                    />
                </div>
                <div class="btn-close" @click="maximizePreview()">
                    {{ $t('label.print.minimize') }}
                </div>
            </div>
        </template>
        <template v-else>
            <div id="center-block" class="hide-scrollbar" :key="`center-block-${selectedState.stateID}-${currentStep}`">
                <div class="product-info" :class="{ collection: bShowStates }">
                    <div
                        class="product-title"
                        v-if="['desktop', 'landscape'].includes($mq) || (['portrait'].includes($mq) && !bShowStates)"
                        :class="[label.image ? 'image' : '']"
                        :style="{
                            backgroundImage: 'url(' + (label.local_image ? label.local_image : label.image ? label.image : '') + ')'
                        }"
                    >
                        {{ formatDisplayMeasurement(label.name) }}
                    </div>
                    <!-- contador collections portrait -->
                    <div class="counter" v-if="bShowStates && ['portrait'].includes($mq)" :class="{ 'can-not-print': !canPrintMutlipleLabels }">
                        <div class="value">{{ completedLabelsCount }}/{{ currentDisplayCount }}</div>
                        <div class="description">
                            {{ capitalizeFirstLetter($t('label.print.labels')) }}
                        </div>
                    </div>
                    <div class="collection-btn" :class="{ selected: bShowStates }" v-if="['portrait'].includes($mq) && states && states.length > 1" @click="togglePreviewCollectionPortrait()"></div>
                    <div class="preview-btn" :class="{ selected: showPreviewPortrait, disabled: !canShowPreview }" v-if="['portrait'].includes($mq)" @click="togglePreviewPortrait()"></div>
                </div>
                <!-- wizard mobile -->
                <div class="wizard hide-scrollbar" v-if="processTypes.length > 0 && ['portrait'].includes($mq) && !bShowStates">
                    <!-- <div class="resume hide-scrollbar" v-if="processTypes.length > 2">
                        <div v-for="(pType, i) in processTypes" class="resume-step" :class="[currentStep >= i ? 'done' : 'undone', { current: currentStep == i }]" :style="{ width: 100 / (processTypes.length - 1) + '%' }"></div>
                    </div> -->
                    <div class="nav hide-scrollbar">
                        <div class="action left" @click="changeStep(currentStep - 1)">
                            <template v-if="currentStep > 0">
                                <button class="back"></button>
                                <div class="text" v-if="!['portrait'].includes($mq) && stepByIndex(currentStep - 1)">
                                    {{ stepByIndex(currentStep - 1).title }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="empty"></div>
                            </template>
                        </div>
                        <div class="current-action" v-if="stepByIndex(currentStep)">
                            {{ stepByIndex(currentStep).title }}
                        </div>

                        <div
                            class="action right"
                            :class="[
                                {
                                    none: currentStep == processTypes.length - 1
                                },
                                {
                                    disabled: wizardStepDisabled
                                }
                            ]"
                            @click="changeStep(currentStep + 1)"
                        >
                            <button class="next"></button>
                        </div>
                    </div>
                </div>
                <!-- wizard desktop -->
                <div class="wizard hide-scrollbar" v-if="processTypes.length > 0 && !['portrait'].includes($mq)">
                    <div class="resume hide-scrollbar" v-if="processTypes.length > 2">
                        <div
                            v-for="(pType, i) in processTypes"
                            class="resume-step"
                            :class="[currentStep >= i ? 'done' : 'undone', { current: currentStep == i }]"
                            :style="{
                                width: 100 / (processTypes.length - 1) + '%'
                            }"
                        ></div>
                    </div>
                    <div class="nav hide-scrollbar">
                        <div class="action left" @click="changeStep(currentStep - 1)">
                            <template v-if="currentStep > 0">
                                <button class="back"></button>
                                <div class="text" v-if="stepByIndex(currentStep - 1)">
                                    {{ stepByIndex(currentStep - 1).title }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="empty"></div>
                            </template>
                        </div>
                        <div class="current-action" v-if="stepByIndex(currentStep)">
                            {{ stepByIndex(currentStep).title }}
                        </div>
                        <template v-if="currentStep < processTypes.length - 1">
                            <div
                                class="action right"
                                :class="{
                                    disabled: wizardStepDisabled
                                }"
                                @click="changeStep(currentStep + 1)"
                            >
                                <div class="text" v-if="stepByIndex(currentStep + 1)">
                                    {{ stepByIndex(currentStep + 1).title }}
                                </div>
                                <button class="next"></button>
                            </div>
                        </template>
                        <!-- <template v-else>
            <div class="action right" @click="print()">
              <button
                class="print"
                :class="{disabled: printer_available}"
              >{{$t("label.print.print")}}</button>
            </div>
          </template>-->
                    </div>
                </div>
                <div class="content hide-scrollbar" v-if="!bShowStates || !['portrait'].includes($mq)" :key="`content-${selectedState.stateID}-${currentStep}`">
                    <div v-for="(pType, i) in processTypes" :key="`step-${selectedState.stateID}-${i}-` + stepKeySuffix(pType, i)" class="step hide-scrollbar" :class="[stepByIndex(i) && stepByIndex(i).result ? 'done' : 'undone', { current: currentStep == i }]">
                        <template v-if="currentStep == i && stepByIndex(i)">
                            <template v-if="!['portrait'].includes($mq) || (['portrait'].includes($mq) && !showPreviewPortrait && !changeDatePrintPortrait)">
                                <template v-if="pType == 'state'">
                                    <div class="tags hide-scrollbar" :class="'p-' + pType">
                                        <div class="carrousel">
                                            <div
                                                :key="index"
                                                v-for="(tag, index) in data[i].tags"
                                                class="tag"
                                                :class="{
                                                    selected: data[i].result == tag.name
                                                }"
                                                @click="setProcessResult(pType, i, tag)"
                                            >
                                                {{ tag.name.length > 40 ? tag.name.substring(0, 40) + '...' : tag.name }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="pType == 'date' || pType == 'datefree'">
                                    <div class="fcalendar-container input" :class="['p-' + pType, { related: filterRelatedLabels }]">
                                        <CalendarSelector :minDate="data[i].minDate" :maxDate="data[i].maxDate" :givenValue="data[i].result" @input="setProcessResult(pType, i, $event)" :key="calendarKey"></CalendarSelector>
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                        <div v-if="filterRelatedLabels" class="related-labels">
                                            <relatedValues :values="filterRelatedLabels" :type="pType" @select="selectRelatedValue(pType, i, $event)"></relatedValues>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'datepast'">
                                    <div class="fcalendar-container input" :class="['p-' + pType, { related: filterRelatedLabels }]">
                                        <CalendarSelector :minDate="data[i].minDate" :maxDate="data[i].maxDate" :givenValue="data[i].result" @input="setProcessResult(pType, i, $event)" :pastDates="true" :key="calendarKey"></CalendarSelector>
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                        <div v-if="filterRelatedLabels" class="related-labels">
                                            <relatedValues :values="filterRelatedLabels" :type="pType" @select="selectRelatedValue(pType, i, $event)"></relatedValues>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'datetime' || pType == 'datetimefree' || pType == 'datetimepast'">
                                    <div class="fcalendar-container input" :class="['p-' + pType, { related: filterRelatedLabels }]">
                                        <DateTimeSelector :show="pType == 'datetime'" :minDate="data[i].minDate" :maxDate="data[i].maxDate" :givenValue="data[i].result" @input="setProcessResult(pType, i, $event)" :key="calendarKey"> </DateTimeSelector>
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                        <div v-if="filterRelatedLabels" class="related-labels">
                                            <relatedValues :values="filterRelatedLabels" :type="pType" @select="selectRelatedValue(pType, i, $event)"></relatedValues>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'time'">
                                    <div class="input-number" :class="'p-' + pType">
                                        <!-- :key="selectTimeHour" -->
                                        <HourTimeSelector :givenValue="data[i].result" @input="setProcessResult(pType, i, $event)"></HourTimeSelector>
                                    </div>
                                    <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                        <span class="text">
                                            {{ $t('label.multiple_print.error_field_msg') }}
                                        </span>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'string'">
                                    <div class="input-text input" :class="['p-' + pType, { related: filterRelatedLabels }]">
                                        <InputTicketing :ref="`step-${i}`" required :givenValue="data[i].result" @handleFocus="condensedView" @input="setProcessResult(pType, i, $event)" @blockNext="blockNext" :key="currentStep"></InputTicketing>
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                        <div v-if="filterRelatedLabels" class="related-labels">
                                            <relatedValues :values="filterRelatedLabels" :type="pType" @select="selectRelatedValue(pType, i, $event)"></relatedValues>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'number'">
                                    <div class="input-number" :class="'p-' + pType">
                                        <Numpad @sendValue="setProcessValue(pType, i, $event)" :decimal="true" :givenValue="data[i].result" :max="data[i].max ? data[i].max : null"> </Numpad>
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'quantity'">
                                    <div class="input-number" :class="'p-' + pType" :key="`quantity-${selectedState.stateID}-${data[i].result}`">
                                        <div v-if="isMultiStatusFlagEnabled" class="no-quantity-message-container">
                                            <div class="no-quantity-message">
                                                <i class="andy-icon i-andy-info-main i-andy-m"></i>
                                                <span>{{ $t('label.no_quantity_product') }}</span>
                                            </div>
                                        </div>

                                        <Numpad v-else @sendValue="setProcessValue(pType, i, $event)" :quantity="true" :givenValue="data[i].result ? data[i].result : label.quantity ? label.quantity : '1'" :startNumber="1" :max="data[i].max ? data[i].max : null" />
                                        <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                            <span class="text">
                                                {{ $t('label.multiple_print.error_field_msg') }}
                                            </span>
                                        </div>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'barcode'">
                                    <div class="input-number" :class="'p-' + pType">
                                        <Barcode @sendValue="setProcessValue(pType, i, $event)" @nextStep="changeStep(currentStep + 1)" @handleFocus="condensedView" :givenValue="data[i].result"></Barcode>
                                    </div>
                                    <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                        <span class="text">
                                            {{ $t('label.multiple_print.error_field_msg') }}
                                        </span>
                                    </div>
                                </template>

                                <template v-else-if="pType == 'previous_labels'">
                                    <div>
                                        <PreviousLabels @sendValue="setProcessResult(pType, i, $event)" @nextStep="changeStep(currentStep + 1)" :state="label.states[processData.selectedState.id]" :rules="data[i].rules" :givenValue="data[i].result" :referenceId="label.id"></PreviousLabels>
                                    </div>
                                    <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                        <span class="text">
                                            {{ $t('label.multiple_print.error_field_msg') }}
                                        </span>
                                    </div>
                                </template>
                                <!-- PHOTO SECTION -->
                                <template v-else-if="pType == 'photo'">
                                    <PhotoLabel :data="data[i]" :productId="label.id" @update-data="(value) => (data[i] = value)" :previewData="newPreviewData"> </PhotoLabel>
                                    <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                        <span class="text">
                                            {{ $t('label.multiple_print.error_field_msg') }}
                                        </span>
                                    </div>
                                </template>
                                <!-- ANDY UNIQUE QR -->
                                <template v-else-if="pType == 'aqr'">
                                    <div class="input-number" :class="'p-' + pType">
                                        <AndyUniqueQr @sendValue="setProcessResult(pType, i, $event)" @nextStep="changeStep(currentStep + 1)" @handleFocus="condensedView" :givenValue="data[i].result" :referenceId="label.id"></AndyUniqueQr>
                                    </div>
                                    <div class="can-not-print" v-if="multiplePrint && !canPrint(selectedState) && !isOptional(data[i])">
                                        <span class="text">
                                            {{ $t('label.multiple_print.error_field_msg') }}
                                        </span>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-if="isLoadedRelatedLabels">
                            <div class="alert-box" v-if="currentStep > 0 && currentStep < data.length - 1 && isErrorRelatedLabels">
                                <ConnectionBox gType="connection" @reload="reloadRelatedLabels"></ConnectionBox>
                            </div>
                        </template>
                    </div>
                </div>

                <!-- Collection PORTRAIT -->
                <div class="preview-info hide-scrollbar" v-if="bShowStates && ['portrait'].includes($mq)" :class="{ 'print-all-mode': isCollectionRules() && printMode === 'printAll' }">
                    <!-- <div class="titl">{{ $t('label.print.labels_to_print') }}</div> -->

                    <div class="states_labels hide-scrollbar" :key="`states-labels-${selectedState.stateID}-${iStateCompleted}`">
                        <div v-for="(state, index) in displayStates" :key="`state-${state.id}-${state.stateID}-${state.collectionID}-${state.referenceID}-${isLabelSelectedToPrint(state)}`" class="state-label-container">
                            <div class="input-selector" @click="toggleLabelSelectionToPrint(state)" v-if="isCollectionRules() && printMode === 'printAll'"></div>
                            <input v-if="isCollectionRules() && printMode === 'printAll'" :class="{ 'can-not-print': !canPrint(state) }" type="checkbox" :checked="isLabelSelectedToPrint(state)" />
                            <StateLabel :id="state.id" :stateID="state.stateID" :collectionID="state.collectionID" :referenceID="state.referenceID" :name="state.name" :state="state.state" :image="state.image" :quantity="state.quantity" :stateData="state.states[Object.keys(state.states)[0]]" :selectedState="label" :show-images="showImages" @changeSelectedState="changeSelectedState($event)" :toPrintSelected="isLabelSelectedToPrint(state) && printMode === 'printAll'" :customClass="[isCollectionRules() && printMode === 'printAll' ? 'print-all-mode' : '', !canPrint(state) ? 'can-not-print' : '']"> </StateLabel>
                        </div>
                    </div>
                </div>
                <div class="footer" v-if="['portrait'].includes($mq) && !changeDatePrintPortrait && !bShowStates">
                    <div class="can-not-print" v-if="multiplePrint && !canPrintMutlipleLabels">
                        <span class="text">
                            {{ $t('label.multiple_print.error_all_fields_msg') }}
                        </span>
                    </div>
                    <button @click="cancel()" class="act cancel">
                        {{ $t('label.print.cancel') }}
                    </button>
                    <div class="actions-container">
                        <button
                            v-if="showWizardNextButton"
                            class="act save"
                            :class="{
                                disabled: wizardStepDisabled
                            }"
                            @click="onTemporalWizardNext"
                        >
                            {{ $t('label.print.next') }}
                        </button>
                        <div class="print-mode-selector" v-else-if="isCollectionRules()">
                            <button @click="printAllSelected" class="act save">
                                {{ printButtonText }}
                            </button>
                            <i v-if="!isTemporalTimerCollection" class="i-andy-menu-config i-andy-m" @click="openPrintConfigModal"></i>
                        </div>
                        <button
                            v-else
                            class="act save print"
                            :class="{
                                disabled: (printer_available && !digitalState) || current_error || blockNextButton || finalPrintQuantityInvalid,
                                digital: digitalState
                            }"
                            @click=";(printer_available && !digitalState) || finalPrintQuantityInvalid ? false : print()"
                        >
                            {{ wizardFinalButtonText }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="column right hide-scrollbar" v-if="!['portrait'].includes($mq) || (['portrait'].includes($mq) && showPreviewPortrait && !changeDatePrintPortrait)">
                <div v-if="states && states.length > 1 && !['portrait'].includes($mq)" class="collections_header">
                    <div class="counter" :class="{ 'can-not-print': !canPrintMutlipleLabels }">
                        <div class="value">{{ completedLabelsCount }}/{{ currentDisplayCount }}</div>
                        <div class="description">
                            {{ capitalizeFirstLetter($t('label.print.labels')) }}
                        </div>
                    </div>
                    <div class="change_view">
                        <span @click="bShowStates = !bShowStates" v-if="!bShowStates">{{ $t('label.print.see_all_labels') }}</span>
                        <span @click="bShowStates = !bShowStates" v-else-if="bShowStates && canShowPreview">{{ $t('label.print.see_preview') }}</span>
                    </div>
                </div>

                <!-- Category -->
                <template v-if="Object.keys(getPrinters).length > 1">
                    <div class="titl">
                        {{ $t('label.print.title_printer') }}
                        <select
                            :value="currentPrinter"
                            @input="
                                (v) => {
                                    currentPrinter = v.target.value
                                }
                            "
                        >
                            <option v-for="printer in getPrinters" :key="printer.id" :value="printer.id">
                                {{ printer.name }}
                            </option>
                        </select>
                    </div>
                </template>
                <template v-if="!bShowStates && (previewPrint.length > 0 || newPreview)">
                    <div
                        class="preview-info hide-scrollbar"
                        :class="[
                            {
                                'portrit-selector': ['portrait'].includes($mq) && Object.keys(getPrinters).length > 1
                            },
                            {
                                'desktop-labelling-collection': ['desktop'].includes($mq) && states && states.length > 1
                            },
                            {
                                'landscape-labelling-collection': ['landscape'].includes($mq) && states && states.length > 1
                            },
                            { 'desktop-labelling': ['desktop'].includes($mq) },
                            {
                                'landscape-labelling': ['landscape'].includes($mq)
                            },
                            {
                                'print-all-mode': isCollectionRules() && printMode === 'printAll'
                            }
                        ]"
                    >
                        <div class="preview-title">
                            <div class="titl">
                                {{ ['portrait'].includes($mq) ? $t('label.print.title_short') : $t('label.print.title') }}
                            </div>
                            <div class="maximize-preview" v-if="newPreview && ['landscape', 'desktop'].includes($mq)" @click="maximizePreview()"></div>
                        </div>

                        <div class="preview scrollbar" v-if="!newPreview">
                            <div class="row" v-for="(row, i) in previewPrint" :key="i">
                                <div class="col" v-for="(col, j) in row" :class="['c' + col.l, col.current ? 'current' : '']" :key="j">
                                    <VueBarcode v-if="col.barcode" v-bind:value="col.v" :height="barcodeConfig.height" :format="barcodeConfig.format">
                                        <span v-html="col.v != '' ? col.v : '-'"></span>
                                    </VueBarcode>
                                    <span v-else v-html="col.v != '' ? col.v : '-'"></span>
                                </div>
                            </div>
                            <!-- <div class="row" v-if="previewPrint.length == 0">
                            <div class="col c4"><span v-html="$t('label.print.errors.invalid_configuration')"></span></div>
                        </div> -->
                        </div>
                        <template v-else>
                            <div class="zpl-preview-wrapper">
                                <Preview
                                  v-if="!isAZplValid"
                                  :refresh="!scanningQR"
                                  :key="currentStep"
                                  :calculate="calculate"
                                  :data="newPreviewData">
                                </Preview>

                                <ZplPreview
                                  v-else
                                  :data="zpl"
                                  :density="density"
                                  :width="labelWidth"
                                  :height="labelHeight"
                                  :values="zplValues"
                                  :params="zplParams"
                                  :showControls="false"
                                  :fitToContainer="true"
                                  :previewScale="2"
                                  :scale="1"
                                  :key="zplKey"
                                />
                            </div>
                        </template>

                        <template v-if="type != 'timerproduct' && (bFreeLabelling || bPastLabelling)">
                            <div class="print_date" v-if="['portrait'].includes($mq)">
                                <div class="section">
                                    <div class="meta">
                                        <div class="label">
                                            {{ $t('label.print.print_date') }}
                                        </div>
                                        <div class="value">
                                            {{ formatDisplayDate(!bUpdatedPrintDateVisible ? init_date : print_date, { includeTime: true }) }}
                                        </div>
                                    </div>
                                    <div class="action" @click.self="changeDatePrintPortrait = !changeDatePrintPortrait">
                                        {{ $t('menu_aux.action.change') }}
                                    </div>
                                </div>
                                <div class="section date" v-if="bUpdatedPrintDateVisible">
                                    <div class="modify_date">
                                        {{ $t('label.print.modify_date') }}
                                    </div>
                                </div>
                            </div>
                            <div class="print_date" v-else @click="changeDatePrintPortrait = !changeDatePrintPortrait">
                                <div class="section">
                                    <div class="label">
                                        {{ $t('label.print.print_date') }}
                                    </div>
                                    <div class="value" @click="changePrintDate('')">
                                        {{ formatDisplayDate(!bUpdatedPrintDateVisible ? init_date : print_date, { includeTime: true }) }}
                                    </div>
                                </div>
                                <div class="section" v-if="bUpdatedPrintDateVisible">
                                    <div class="modify_date">
                                        {{ $t('label.print.modify_date') }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="quantity" v-if="quantityStep && ['landscape', 'desktop', 'portrait'].includes($mq)" :key="`quantity-display-${selectedState.stateID}-${quantityStep.result}`">
                            <span>
                                <span class="units">{{ quantityStep.result != '' ? quantityStep.result : label.quantity ? label.quantity : '1' }}</span>
                                {{ parseInt(quantityStep.result) > 1 || parseInt(label.quantity) > 1 ? $t('label.print.labels') : $t('label.print.label') }}
                            </span>
                        </div>
                    </div>
                </template>

                <!-- INVALID PRINTER -->
                <template v-else-if="!bShowStates && previewPrint.length == 0 && !newPreview">
                    <div class="preview-error">
                        <div class="error-message" v-html="$t('label.print.errors.invalid_configuration')"></div>
                        <button class="btn" @click="goToConfig">
                            {{ $t('label.print.errors.invalid_configuration_action') }}
                        </button>
                    </div>
                </template>

                <!-- Collection -->
                <template v-else>
                    <div
                        class="preview-info collection hide-scrollbar"
                        :class="[
                            {
                                'collection-desktop': ['desktop'].includes($mq)
                            },
                            {
                                'print-all-mode': isCollectionRules() && printMode === 'printAll'
                            }
                        ]"
                    >
                        <div class="titl">
                            {{ $t('label.print.labels_to_print') }}
                        </div>
                        <div class="states_labels hide-scrollbar" :key="`states-labels-desktop-${selectedState.stateID}-${iStateCompleted}`">
                            <div v-for="(state, index) in displayStates" :key="`state-desktop-${state.id}-${state.stateID}-${state.collectionID}-${state.referenceID}-${isLabelSelectedToPrint(state)}-${index}`" class="state-label-container">
                                <div class="input-selector" @click="toggleLabelSelectionToPrint(state)" v-if="isCollectionRules() && printMode === 'printAll'"></div>
                                <input v-if="isCollectionRules() && printMode === 'printAll'" :class="{ 'can-not-print': !canPrint(state) }" type="checkbox" :checked="isLabelSelectedToPrint(state)" />
                                <StateLabel :id="state.id" :stateID="state.stateID" :collectionID="state.collectionID" :referenceID="state.referenceID" :name="state.name" :state="state.state" :image="state.image" :quantity="state.quantity" :stateData="state.states[Object.keys(state.states)[0]]" :selectedState="label" :show-images="showImages" @changeSelectedState="changeSelectedState($event)" :toPrintSelected="isLabelSelectedToPrint(state) && printMode === 'printAll'" :customClass="[isCollectionRules() && printMode === 'printAll' ? 'print-all-mode' : '', !canPrint(state) ? 'can-not-print' : '']"> </StateLabel>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- <div class="portrait-footer" v-if="['portrait'].includes($mq)"> -->
                <!-- <button @click="cancel()" class="act cancel">{{ $t('label.print.cancel') }}</button> -->

                <!-- <button v-if="currentStep < processTypes.length - 1" class="act save" @click="togglePreviewPortrait()">{{ $t('menu_aux.action.continue') }}</button>
                    <button v-else class="act save print" :class="{ disabled: (printer_available && !digitalState) || current_error || parseInt(data[processTypes.length - 1].result) == 0 || parseInt(data[processTypes.length - 1].result) > parseInt(data[processTypes.length - 1].max), digital: digitalState }" @click=";(printer_available && !digitalState) || parseInt(data[processTypes.length - 1].result) == 0 || parseInt(data[processTypes.length - 1].result) > parseInt(data[processTypes.length - 1].max) ? false : print()">{{ digitalState ? $t('label.print.save') : $t('label.print.print') }}</button> -->
                <!-- </div> -->
                <div class="footer" v-if="['landscape', 'desktop'].includes($mq) || (['portrait'].includes($mq) && !showPreviewPortrait && !changeDatePrintPortrait)">
                    <div class="can-not-print" v-if="multiplePrint && !canPrintMutlipleLabels">
                        <span class="text">
                            {{ $t('label.multiple_print.error_all_fields_msg') }}
                        </span>
                    </div>
                    <button @click="cancel()" class="act cancel">
                        {{ $t('label.print.cancel') }}
                    </button>

                    <button
                        v-if="showWizardNextButton"
                        class="act save"
                        :class="{
                            disabled: wizardStepDisabled
                        }"
                        @click="onTemporalWizardNext"
                    >
                        {{ $t('label.print.next') }}
                    </button>
                    <div class="print-mode-selector" v-else-if="isCollectionRules()">
                        <button @click="printAllSelected" class="act save">
                            <i v-if="!isTemporalTimerCollection" class="i-andy-printer i-andy-l"></i>
                            {{ printButtonText }}
                        </button>
                        <i v-if="!isTemporalTimerCollection" class="i-andy-menu-config i-andy-l" @click="openPrintConfigModal"></i>
                    </div>
                    <button
                        v-else
                        class="act save print"
                        :class="{
                            disabled: (printer_available && !digitalState) || current_error || blockNextButton || finalPrintQuantityInvalid,
                            digital: digitalState
                        }"
                        @click=";(printer_available && !digitalState) || finalPrintQuantityInvalid ? false : print()"
                    >
                        {{ wizardFinalButtonText }}
                    </button>
                </div>
            </div>

            <date-time-portrait :only_past="bPastLabelling" @cancel="changeDatePrintPortrait = false" @updatePrintDate="changePrintDate" v-else-if="changeDatePrintPortrait && showPreviewPortrait" :value="!bUpdatedPrintDateVisible ? init_date.format('DD/MM/YYYY HH:mm') : print_date.format('DD/MM/YYYY HH:mm')" :date="print_date.format('DD/MM/YYYY')" :time="print_date.format('HH:mm')" :changePrintDate="changeDatePrintPortrait"></date-time-portrait>
        </template>
    </div>
</template>

<script>
import { formatMeasurementLabel } from '@/utils/numberFormat'

import { formatPrintedDateFromStore, formatDisplayDateFromStore } from '@/utils/dateFormatters'
import Preview from '@/components/domain/label/preview.vue'
import ZplPreview from '@/components/domain/label/ZplPreview'
import i18n from '@/i18n'
import Numpad from '@/components/inputs/Numpad'
import InputTicketing from '@/components/inputs/InputTicketing'
import CalendarSelector from '@/components/inputs/CalendarSelector'
import HourTimeSelector from '@/components/inputs/HourTimeSelector'
import DateTimeSelector from '@/components/inputs/DateTimeSelector'
import StateLabel from '@/components/domain/label/StateLabel'
import Barcode from '@/components/inputs/Barcode'
import VueBarcode, { data } from 'vue-barcode'
import DateTimePortrait from '@/components/domain/label/dateTimePortrait.vue'
import relatedValues from '@/components/domain/label/relatedValues'
import PreviousLabels from '@/components/domain/label/previousLabels'
import ConnectionBox from '../ui/Box.vue'
import PhotoLabel from '@/components/domain/label/photoLabel.vue'
import AndyUniqueQr from '@/components/inputs/AndyQRUnique.vue'
import {
    buildZplPreviewState,
    createPrinterStoreAccessors,
    extractZPLFromPrinter as extractZPLFromPrinterUtil,
    isValidZPL as isValidZplString,
    resolveFormatForPrint as resolveFormatForPrintUtil
} from '@/utils/zplPreviewHelpers.js'
import { arePrintFieldsComplete, getSelectedPrintItemsInOrder, getWizardCollectionDisplayStates, insertPrintItemAfterCurrent, isPrintItemSelected, samePrintItemId, snapshotPrintAllItems, togglePrintItemSelection } from '@/utils/timerProductTemporalCollection'
import { getProcessStep, isPrintQuantityInvalid, parsePrintFormatData } from '@/utils/printWizardSteps'

export default {
    name: 'Print',
    components: {
        Numpad,
        InputTicketing,
        CalendarSelector,
        DateTimeSelector,
        HourTimeSelector,
        StateLabel,
        Barcode,
        VueBarcode,
        Preview,
        ZplPreview,
        DateTimePortrait,
        relatedValues,
        PreviousLabels,
        ConnectionBox,
        PhotoLabel,
        AndyUniqueQr,
        ZplPreview
    },
    props: {
        states: {
            type: Array,
            default: []
        },
        printer_available: Boolean,
        labelStateSelected: String,
        type: {
            type: String,
            default: 'label'
        },
        selectedCollection: {
            type: [String, Number],
            default: ''
        },
        /**
         * BUILD-7687: oculta foto de producto en el wizard de alta.
         * Default true para no cambiar el flujo de etiquetas.
         */
        showImages: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            calculate: 0,
            fullPreview: false,
            newPreviewData: {},
            newPreview: true,
            selectTimeHour: 0,
            data: [],
            processData: {},
            processTypes: [],
            currentStep: 0,
            oParams: {},
            printData: [],
            previewPrint: [],
            onFocus: false,
            current_error: false,
            current_template_error: false,
            bShowStates: false,
            selectedState: {},
            iStateIndex: 0,
            iStateCompleted: 0,
            label: {},
            init_date: false,
            print_date: false,
            bUpdatedPrintDate: false,
            bUpdatedPrintDateVisible: false,
            barcodeConfig: {
                format: 'CODE39',
                height: '35'
            },
            digitalState: false,
            blockNextButton: false,

            // PORTRAIT VARIABLES OF CONTROL
            showPreviewPortrait: false,
            changeDatePrintPortrait: false,
            timezone: null,
            relatedLabels: {},
            // create custom key to avoid problems for using date[i].result in this case
            // (rerender when is not supposted to when click on calendar or time)
            calendarKey: 0,
            autoDateCalc: false,
            isLoadedRelatedLabels: false,
            isErrorRelatedLabels: false,

            // Variables para imprimir todo/seleccionadas
            isPrintAllCollection: true,
            showPrintAllMode: true, // Por defecto en modo "Imprimir Todo"
            printMode: 'printAll', // Modo actual de impresión
            selectedLabelsToPrint: [],
            /**
             * Distingue “aún no inicializado” de “el usuario deseleccionó todo”.
             * Si no, un selectedLabelsToPrint vacío vuelve a marcar todos.
             */
            temporalSelectionInitialized: false,
            canShowPreview: true,
            multipleLabelsToPrint: [],

            zpl: '',
            density: 203,
            labelWidth: 55,
            labelHeight: 50,
            zplValues: {},
            zplParams: {},
            zplKey: 0,
            fullPreviewContentSize: { width: 0, height: 0 },
            fullPreviewResizeObserver: null,
            isAZplValid: false
        }
    },
    computed: {
        isMultiStatusFlagEnabled() {
            return this.label && this.label.reference_config && this.label.reference_config.multistatus && this.label.reference_config.multistatus === 1
        },
        previewNormalScale() {
            if (this.isAZplValid || !this.fullPreview || !this.newPreviewData || !this.newPreviewData.width || !this.newPreviewData.height) {
                return 1
            }
            const w = this.fullPreviewContentSize.width
            const h = this.fullPreviewContentSize.height
            if (w <= 0 || h <= 0) return 1
            const contentW = this.newPreviewData.width * 7
            const contentH = this.newPreviewData.height * 7
            if (contentW <= 0 || contentH <= 0) return 1
            return Math.min(1, w / contentW, h / contentH)
        },
        previewNormalFitScaledStyle() {
            if (this.isAZplValid || !this.newPreviewData || !this.newPreviewData.width || !this.newPreviewData.height) {
                return {}
            }
            const contentW = this.newPreviewData.width * 7
            const contentH = this.newPreviewData.height * 7
            const scale = this.previewNormalScale
            return {
                width: Math.round(contentW * scale) + 'px',
                height: Math.round(contentH * scale) + 'px'
            }
        },
        previewNormalFitInnerStyle() {
            if (this.isAZplValid || !this.newPreviewData || !this.newPreviewData.width || !this.newPreviewData.height) {
                return {}
            }
            const contentW = this.newPreviewData.width * 7
            const contentH = this.newPreviewData.height * 7
            const scale = this.previewNormalScale
            return {
                width: contentW + 'px',
                height: contentH + 'px',
                transform: `scale(${scale})`,
                transformOrigin: 'top left'
            }
        },

        bFreeLabelling() {
            return parseInt(this.$store.getters['getFreeLabelling']) == 1
        },

        bPastLabelling() {
            return parseInt(this.$store.getters['getPastLabelling']) == 1
        },

        connection() {
            return this.$store.getters['getConnState']
        },

        currentPrinter: {
            get() {
                var config_id = this.$store.getters['printer/getCurrentPrinter']
                if (config_id && typeof this.getPrinters[config_id] !== 'undefined') return config_id
                this.$store.dispatch('printer/setCurrentPrinter', Object.keys(this.getPrinters)[0])
                return Object.keys(this.getPrinters).length > 0 ? Object.keys(this.getPrinters)[0] : false
            },
            set(value) {
                this.$store.dispatch('printer/setCurrentPrinter', value)
            }
        },

        checkingPrinter() {
            return this.$store.getters['printer/isCheckingStatusPrinter']
        },

        printerAvailable() {
            return this.$store.getters['printer/getStatusPrinter']
        },

        getPrinters() {
            var printers = this.$store.getters['printer/getPrinterConfig']()
            var oPrinters = {}
            for (var p in printers) {
                if (this.$store.getters.getIsApp && (printers[p].mode == 'WIFI' || printers[p].print_mode == 'wifi' || printers[p].platform == cordova.platformId)) {
                    oPrinters[p] = printers[p]
                } else if (!this.$store.getters.getIsApp && printers[p].platform == 'windows') {
                    oPrinters[p] = printers[p]
                }
            }

            return oPrinters
        },

        isOnCollectionView() {
            return this.states.length > 1
        },

        isTemporalTimerCollection() {
            if (this.type !== 'timerproduct' || !this.selectedCollection) {
                return false
            }
            const collections = this.$store.getters['label/getCollections'] || {}
            const collection = collections[this.selectedCollection]
            return Boolean(collection && collection.temporal)
        },

        showWizardNextButton() {
            const hasMoreSteps = this.currentStep < this.processTypes.length - 1
            if (this.isTemporalTimerCollection) {
                return hasMoreSteps || !this.isLastTemporalProduct
            }
            if (hasMoreSteps) {
                return !this.isCollectionRules()
            }
            return false
        },

        isLastTemporalProduct() {
            const items = this.temporalSelectedItems
            if (items.length === 0) {
                return true
            }
            const currentId = this.label && this.label.id
            const currentIndex = items.findIndex((item) => item && samePrintItemId(item.id, currentId))
            return currentIndex === -1 || currentIndex === items.length - 1
        },

        temporalSelectedItems() {
            if (!this.isTemporalTimerCollection || !this.multiplePrint) {
                return []
            }
            return getSelectedPrintItemsInOrder(this.multiplePrint, this.selectedLabelsToPrint)
        },

        wizardFinalButtonText() {
            return this.digitalState || this.type == 'timerproduct' ? this.$t('label.print.save') : this.$t('label.print.print')
        },

        wizardStepDisabled() {
            const step = this.stepByIndex(this.currentStep)
            if (!step) {
                return true
            }
            const missingRequired = !this.isOptional(step) && step.result == ''
            return missingRequired || this.current_error || this.blockNextButton
        },

        quantityStep() {
            if (!Array.isArray(this.data) || this.data.length === 0) {
                return null
            }
            return getProcessStep(this.data, this.data.length - 1)
        },

        finalPrintQuantityInvalid() {
            const lastIndex = Array.isArray(this.processTypes) ? this.processTypes.length - 1 : -1
            return isPrintQuantityInvalid(getProcessStep(this.data, lastIndex))
        },

        multiplePrint() {
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                // Filtrar etiquetas que solo tengan el step de cantidad
                const multiplePrint = this.$store.getters['label/getMultiplePrint']
                if (this.selectedCollection && multiplePrint[this.selectedCollection] && multiplePrint[this.selectedCollection].length > 0) {
                    const labels = multiplePrint[this.selectedCollection]
                    if (this.isTemporalTimerCollection) {
                        if (!this.temporalSelectionInitialized) {
                            this.selectedLabelsToPrint = labels.map((label) => label.id)
                            this.temporalSelectionInitialized = true
                        }
                    } else {
                        this.selectedLabelsToPrint = []
                        this.selectedLabelsToPrint = labels.filter((label) => label.canPrint).map((label) => label.id)
                    }
                    return labels
                }
                if (!this.isTemporalTimerCollection) {
                    this.selectedLabelsToPrint = []
                }
                return []
            }
        },
        // Etiquetas que se muestran según el modo (todo vs seleccionadas)
        displayStates() {
            // BUILD-7627: en colección temporal los deseleccionados siguen en la lista
            // (estado unchecked). El contador usa temporalSelectedItems, no este listado.
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                return getWizardCollectionDisplayStates(this.multiplePrint)
            }
            // Si está en modo "Imprimir Individual" o no es colección, mostrar todas las etiquetas
            return this.states
        },

        scanningQR() {
            return this.$store.getters['getBarcodeActive']
        },
        filterRelatedLabels() {
            const step = this.stepByIndex(this.currentStep)
            if (!step || !this.processData.selectedState) {
                return false
            }
            const labels = this.relatedLabels[this.processData.selectedState.id]
            const stepKeyName = step.keyname
            const showRelatedLabels = !step.rules || typeof step.rules.related === 'undefined' || (step.rules && step.rules.related == true)

            let result = false

            if (typeof labels !== 'undefined' && typeof labels[stepKeyName] !== 'undefined' && showRelatedLabels) {
                result = []
                for (let label in labels[stepKeyName]) {
                    let value = labels[stepKeyName][label]

                    if (result.indexOf(value) == -1) {
                        result.push(value)
                    }
                }
            }

            return result.length > 0 ? result : false
        },

        tpRound() {
            return this.$store.getters.getTimerProductRound
        },

        // Texto del botón según el modo de impresión
        printButtonText() {
            if (this.isTemporalTimerCollection) {
                return this.$t('timersproduct.add_new_timers')
            }
            return this.printMode === 'printAll' ? this.$t('label.popup.printAll') : this.$t('label.popup.text_save')
        },

        // Contador actualizado según el modo de impresión
        currentDisplayCount() {
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                if (this.isTemporalTimerCollection) {
                    return this.temporalSelectedItems.length
                }
                return this.multiplePrint.length
            }
            return this.states.length
        },

        // Contador de etiquetas completadas según el modo de impresión
        completedLabelsCount() {
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                return this.selectedLabelsToPrint.length
            }
            return this.iStateCompleted
        },
        canPrintMutlipleLabels() {
            if (this.multiplePrint) {
                const canPrint = Object.values(this.multiplePrint).every((label) => this.canPrint(label))
                return canPrint
            }
            return true
        }
    },
    methods: {
        formatDisplayMeasurement(value) {
            return formatMeasurementLabel(value, this.$i18n.locale, count => this.$tc('measurements.unit', count))
        },
        formatDisplayDate: formatDisplayDateFromStore,
        // PORTRAIT METHODS
        togglePreviewPortrait() {
            if (!this.canShowPreview) return
            const serverTimeDifference = this.$store.getters['getServerTimeDifference']

            if (this.showPreviewPortrait) {
                this.showPreviewPortrait = false
                this.changeDatePrintPortrait = false
            } else {
                this.showPreviewPortrait = true
                this.bShowStates = false

                // get date by timezone not from device
                let date = moment()
                if (!this.bUpdatedPrintDate) {
                    try {
                        const options = {
                            timeZone: this.timezone,
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: false
                        }
                        const copy = moment(date)

                        log('1', date.format('DD/MM/YYYY HH:mm'))

                        const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                        const objectDate = {}
                        for (const item of dateTimeFormat) {
                            objectDate[item.type] = item.value
                        }
                        const dateString = `${objectDate['day'].padStart(2, '0')}/${objectDate['month'].padStart(2, '0')}/${objectDate['year']} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`
                        date = moment(dateString, 'DD/MM/YYYY HH:mm')

                        log('2', date.format('DD/MM/YYYY HH:mm'))
                        log('3', date.diff(copy, 'minutes'))
                        log('4', serverTimeDifference)

                        if (date.diff(copy, 'minutes') != serverTimeDifference) {
                            const difference = serverTimeDifference - date.diff(copy, 'minutes')
                            date = date.add(difference, 'minutes')
                        }
                    } catch (error) {
                        logError(error)
                    }
                }

                this.print_date = this.bUpdatedPrintDate ? this.print_date : date
                this.init_date = date
                this.updatePreview()
            }
        },
        canPrint(state) {
            if (!state) {
                return false
            }
            if (typeof state.fields === 'object' && state.fields !== null) {
                const steps = Object.values(state.fields)
                if (steps.length > 0) {
                    return arePrintFieldsComplete(state.fields)
                }
            }
            return Boolean(state.canPrint)
        },
        isOptional(step) {
            if (step.keyname == 'quantity') return true
            return step.optional
        },
        isLabelSelectedToPrint(state) {
            return isPrintItemSelected(this.selectedLabelsToPrint, state && state.id)
        },

        toggleLabelSelectionToPrint(state) {
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                const wasSelected = isPrintItemSelected(this.selectedLabelsToPrint, state.id)
                if (this.isTemporalTimerCollection && wasSelected && this.temporalSelectedItems.length <= 1) {
                    return
                }

                if (wasSelected) {
                    this.selectedLabelsToPrint = togglePrintItemSelection(this.selectedLabelsToPrint, state.id)
                    if (samePrintItemId(this.label && this.label.id, state.id)) {
                        const nextLabel = this.isTemporalTimerCollection
                            ? this.temporalSelectedItems[0]
                            : this.multiplePrint.find((label) => isPrintItemSelected(this.selectedLabelsToPrint, label.id))
                        if (nextLabel) {
                            this.openCollectionProductInWizard(nextLabel, { keepListOpen: true })
                        } else {
                            this.canShowPreview = false
                            this.label = false
                        }
                    }
                    return
                }

                if (this.isTemporalTimerCollection) {
                    // BUILD-7627: se encola detrás del producto actual; no se cambia de wizard
                    this.selectedLabelsToPrint = insertPrintItemAfterCurrent(
                        this.selectedLabelsToPrint,
                        state.id,
                        this.label && this.label.id
                    )
                    return
                }

                this.selectedLabelsToPrint = togglePrintItemSelection(this.selectedLabelsToPrint, state.id)
                const reselected = (this.multiplePrint || []).find((label) => samePrintItemId(label.id, state.id))
                if (!this.label && reselected) {
                    this.label = reselected
                    this.canShowPreview = true
                }
            }
        },

        /**
         * Abre el producto en el wizard de colección. No cambia generateProcess.
         *
         * @param {Object} label
         * @param {{ keepListOpen?: boolean }} [options]
         */
        openCollectionProductInWizard(label, options) {
            if (!label) {
                return
            }
            this.changeSelectedState(
                {
                    id: label.id,
                    stateID: label.stateID,
                    collectionID: label.collectionID,
                    referenceID: label.referenceID
                },
                options
            )
            this.canShowPreview = true
        },

        isCollectionRules() {
            //Validar condiciones para que muestre el botón de imprimir todo y haga todo el proceso de impresión
            //Si es una colección isOnCollectionView es true y isPrintAllCollection es true
            if (this.isOnCollectionView && this.isPrintAllCollection) {
                return true
            }
        },

        // Métodos para el popup de configuración
        openPrintConfigModal() {
            const self = this
            this.$popup.printConfig({
                title: self.$t('label.popup.config_text'),
                options: [
                    {
                        id: 'printAll',
                        text: self.$t('label.popup.printAll')
                    },
                    {
                        id: 'printIndividual',
                        text: self.$t('label.popup.text_save')
                    }
                ],
                selected: self.printMode,
                callSave: function (_self, store) {
                    const selected = _self.selected
                    self.printMode = selected
                    self.$popup.close()
                }
            })
        },

        // Método para imprimir todas las etiquetas seleccionadas
        printAllSelected() {
            if (this.isTemporalTimerCollection) {
                this.syncTemporalCurrentFields()
            }
            if (this.printMode === 'printAll') {
                const selectedLabels = this.multiplePrint.filter((label) => isPrintItemSelected(this.selectedLabelsToPrint, label.id))
                if (selectedLabels.length > 0) {
                    //Validar si las etiquetas seleccionadas tienen todos los steps con un result
                    const canPrint = selectedLabels.every((label) => this.canPrint(label))
                    if (!canPrint) {
                        this.showSnackbarDataMissing()
                        // Encontrar la primera etiqueta que no se puede imprimir
                        const incompleteLabelIndex = selectedLabels.findIndex((label) => !this.canPrint(label))
                        if (incompleteLabelIndex !== -1) {
                            const incompleteLabel = selectedLabels[incompleteLabelIndex]

                            // Cambiar a la etiqueta incompleta
                            this.changeSelectedState({
                                id: incompleteLabel.id,
                                stateID: incompleteLabel.stateID,
                                collectionID: incompleteLabel.collectionID,
                                referenceID: incompleteLabel.referenceID
                            })

                            // Esperar a que se actualice el estado y luego buscar el primer paso obligatorio incompleto
                            this.$nextTick(() => {
                                // Buscar en this.data el primer paso obligatorio que no está completo
                                const incompleteStepIndex = this.data.findIndex((step, index) => {
                                    // Ignorar quantity y state
                                    if (['quantity', 'state'].includes(step.keyname)) return false

                                    // Debe ser obligatorio (no opcional)
                                    if (step.optional) return false

                                    // Debe estar incompleto
                                    const isValid = step.result && step.result != null && step.result != ''
                                    return !isValid
                                })

                                // Si encontramos un paso obligatorio incompleto, navegar a él
                                if (incompleteStepIndex !== -1) {
                                    this.currentStep = incompleteStepIndex
                                }

                                // Mostrar vista de etiquetas si estamos en portrait
                                if (['portrait'].includes(this.$mq)) {
                                    this.bShowStates = false
                                }

                                // Mostrar mensaje informativo
                                this.$snackbar.warning({
                                    message: this.$t('tooltip.print_data_missing_navigate'),
                                    closeable: true,
                                    timeout: 4000
                                })
                            })
                        }
                        return
                    }

                    this.multipleLabelsToPrint = this.isTemporalTimerCollection ? snapshotPrintAllItems(selectedLabels) : selectedLabels
                    this.$emit('printAll', { ...this })
                    this.cancel(true)
                    this.$store.dispatch('label/resetMultiplePrint')
                }
            } else {
                // Modo individual - comportamiento actual
                this.print()
            }
        },

        togglePreviewCollectionPortrait() {
            if (this.bShowStates) {
                this.bShowStates = false
            } else {
                this.bShowStates = true
                this.showPreviewPortrait = false
            }
        },

        maximizePreview() {
            this.fullPreview = !this.fullPreview
            if (this.fullPreview) {
                this.$nextTick(() => this.setupFullPreviewResizeObserver())
            } else {
                this.teardownFullPreviewResizeObserver()
            }
        },
        setupFullPreviewResizeObserver() {
            const el = this.$refs.fullPreviewContent
            if (!el || typeof ResizeObserver === 'undefined') {
                if (el) this.updateFullPreviewContentSize(el)
                return
            }
            this.teardownFullPreviewResizeObserver()
            this.fullPreviewResizeObserver = new ResizeObserver((entries) => {
                const entry = entries[0]
                if (entry && entry.target) this.updateFullPreviewContentSize(entry.target)
            })
            this.fullPreviewResizeObserver.observe(el)
            this.updateFullPreviewContentSize(el)
        },
        teardownFullPreviewResizeObserver() {
            if (this.fullPreviewResizeObserver) {
                this.fullPreviewResizeObserver.disconnect()
                this.fullPreviewResizeObserver = null
            }
        },
        updateFullPreviewContentSize(el) {
            if (!el) return
            const width = el.clientWidth || 0
            const height = el.clientHeight || 0
            if (this.fullPreviewContentSize.width !== width || this.fullPreviewContentSize.height !== height) {
                this.fullPreviewContentSize = { width, height }
            }
        },
        validatePrinterConfiguration(bLaunchUpdate, validatePrinter) {
            // VALIDATE IF CURRENT TEMPLATE IF VALID FOR CURRENT PRINTER
            // 1) THIS CAN BE WHEN TEMPLATE EXISTS ON PRINTER
            // CAN BE TOO WHEN EXISTS TEMPLATE ON PRINTER WHERE HIS PARENT_ID IS THE TEMPLATE
            // 2) WE NEED VALIDATE THEN IF CURRENT PRINTER HAD ALL TEMPLATES LOADED ON PRINTER OR DOWNLOAD IN PATH
            var bLaunchUpdate = typeof bLaunchUpdate !== 'undefined' ? bLaunchUpdate : true
            var validatePrinter = typeof validatePrinter !== 'undefined' ? validatePrinter : false
            var template = this.processData.label.states[this.processData.selectedState.id].format
            var currentPrinterConfig = this.getPrinters[this.currentPrinter]
            var currentPrinter = this.currentPrinter ? this.$store.getters['printer/getModels'](currentPrinterConfig.model) : false
            var templatesPrinter = currentPrinter ? this.$store.getters['printer/getTemplatesByPrinterModel'](currentPrinter.id) : []

            var bErrorFound = false
            if (currentPrinter && typeof templatesPrinter[template] === 'undefined') {
                var templates = this.$store.getters['printer/getTemplates']()
                var bFound = false
                for (var t in templates) {
                    var tpl = templates[t]
                    if (tpl.printer_id == currentPrinterConfig.model && tpl.parent_id == template) {
                        bFound = true
                        log('EXISTE UN TEMPLATE PADRE!', tpl.id, tpl.parent_id, template)
                    }
                }
                bErrorFound = !bFound
            }
            if (currentPrinter && currentPrinterConfig.platform == 'android' && currentPrinter.sdk == 'brother' && (typeof templatesPrinter[template] === 'undefined' || typeof currentPrinterConfig.templates[templatesPrinter[template].label_id] === 'undefined')) {
                var label = templatesPrinter[template] ? this.$store.getters['printer/getLabels'](templatesPrinter[template].label_id) : false
                if (label && !label.tpl_file_app.includes('.z')) {
                    var templates = this.$store.getters['printer/getTemplates']()
                    var bFound = false
                    for (var t in templates) {
                        var tpl = templates[t]
                        if (tpl.printer_id == currentPrinterConfig.model && tpl.parent_id == template && typeof currentPrinterConfig.templates[templatesPrinter[tpl.id].label_id] !== 'undefined') {
                            bFound = true
                        }
                    }
                    bErrorFound = !bFound
                }
            }

            if (bErrorFound) {
                this.current_template_error = true
                this.$snackbar.error({
                    message: i18n.t('config.printer.errors.default2'),
                    closeable: true,
                    action: function () {
                        window.open('https://www.chatbase.co/chatbot-iframe/dKcHrqZbL86S4tl0obHZZ', '_blank')
                    }
                })
                this.previewPrint = []
                this.currentStep = 0
            } else {
                var self = this
                this.$store.dispatch('printer/checkPrinterConfiguration', {}).then(function () {
                    var update = self.$store.getters['printer/getUpdateTemplate']
                    if (update) {
                        self.$popup.alert({
                            closable: false,
                            blocking: false,
                            customClass: 'popup-label-admin',
                            message: self.$t('label.update.message'),
                            textSave: self.$t('label.update.confirm'),
                            textCancel: self.$t('label.update.cancel'),
                            callSave: function () {
                                // self.$router.push("/config/printer");
                                self.$router.push({
                                    name: 'ConfigPage',
                                    params: {
                                        page: 'printer',
                                        update: true,
                                        config_id: update
                                    }
                                })
                            }
                        })
                    } else {
                        if (!self.checkingPrinter) {
                            if (validatePrinter) {
                                if (self.$store.getters.getIsApp) {
                                    self.$store.dispatch('printer/statusPrinter')
                                } else {
                                    self.$store.dispatch('printer/validateBpac')
                                }
                            }

                            self.current_template_error = false
                            self.$snackbar.close()
                            if (bLaunchUpdate) self.updatePreview()
                        }
                    }
                })
            }
        },
        // GET OPERATING SYSTEM
        OS() {
            var system = getOS()
            return system
        },

        setProcessResult(pType, i, result) {
            logError('setProcessResult', pType, i, result)

            this.processBeforeChanges(pType, i, result)
            const serverTimeDifference = this.$store.getters['getServerTimeDifference']

            if (pType == 'state') {
                this.selectedState.name = result.name
                this.selectedState.id = result.id
                this.selectedState.digital = result.digital
                this.blockNextButton = false

                this.processData.selectedState.id = result.id
                this.processData.selectedState.name = result.name
                this.processData.selectedState.digital = result.digital
                // this.data[i].result = result.name;
                // this.data[i].selected = result.id;

                this.generateProcess(false)

                this.autoDateCalc = this.processTypes.includes('previous_labels')
                // Calculo de maxDate en funcion de estado
                // var datePos = this.processTypes.indexOf('date');
                // this.data[datePos].maxDate = moment().add(this.data[i].tags[result.id].time, 'minutes').format('D/M/YYYY');
            } else if (pType == 'date' || pType == 'datepast') {
                this.data[i].result = moment(result, 'YYYY/MM/DD').format('DD/MM/YYYY') + moment().add(serverTimeDifference, 'minutes').format(' HH:mm')
                // alert('1 ' + this.data[i].result)
            } else if (pType == 'time') {
                this.data[i].result = result
            }
            // else if (pType == "datetime") {
            //   let date =
            //     Object.keys(this.data[i].date).length > 0
            //       ? this.data[i].date.selectedDate
            //       : "";
            //   let time = this.data[i].time ? this.data[i].time : "";

            //   this.data[i].result = date + " " + time;
            // }
            else if (['datefree', 'datetimefree'].includes(this.data[i].type)) {
                if (result != '') {
                    if (this.data[i].type == 'datefree') result = moment(result, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm')
                    this.data[i].result = moment(result, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')

                    if (!this.data[i].rules || typeof this.data[i].rules.modprintd === 'undefined' || this.data[i].rules.modprintd) {
                        this.oParams['initdate'] = this.data[i].result
                    }
                }
            } else if (pType == 'previous_labels' || pType == 'aqr') {
                if (pType == 'aqr') {
                    if (result.reference != this.label.id) {
                        this.$snackbar.error({
                            message: i18n.t('label.previous_labels.no_results'),
                            closeable: true
                        })
                        this.current_template_error = true
                        return
                    } else {
                        this.current_template_error = false
                        result = result.data
                    }
                }
                let label = JSON.parse(result)
                this.autoDateCalc = true

                for (var k in label) {
                    let params_to_ignore = pType == 'aqr' ? /date|prep_date|print_date|employee|employee_name|product|bUpdatedPrintDate|state|quantity|cantidad|aqr|caducidad/ : /prep_date|print_date|employee|employee_name|product|bUpdatedPrintDate|state|quantity|cantidad|aqr/
                    if (!params_to_ignore.test(k)) {
                        if (['note', 'note1', 'note2', 'note3'].includes(k) && (!this.oParams[k] || this.oParams[k].trim() == '')) {
                            this.oParams[k] = label[k]
                        } else if (this.oParams[k]) {
                            this.oParams[k] = label[k]
                        }

                        if (k.includes('_timestamp')) {
                            let k_aux = k.replace('_timestamp', '')
                            let dateAux = moment(parseInt(label[k]) * 1000)

                            if (parseInt(label[k_aux]) == label[k_aux]) {
                                // CASO BARCODE LA FECHA EN LA VARIABLE ES UN TIMESTAMP
                                this.oParams[k_aux] = dateAux.format('DD/MM/YYYY HH:mm') //initial value
                            } else {
                                // LA FECHA VIENE EN EL FORMATO ESPERADO
                                this.oParams[k_aux] = label[k_aux] //initial value
                            }

                            this.oParams[k] = label[k] //timestamp
                            this.oParams[k_aux + '_datetime'] = this.oParams[k_aux]
                            this.oParams[k_aux + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k_aux + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k_aux + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k_aux + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k_aux + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k_aux + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k_aux + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k_aux + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k_aux + '_time'] = dateAux.format('HH:mm')
                        } else if (k.match(/ingr.{1,2}date$/gi) || k.match(/ingr.{1,2}rec$/gi)) {
                            let dateAux = moment(label[k], 'DD/MM/YYYY HH:mm')
                            this.oParams[k] = label[k]
                            this.oParams[k + '_datetime'] = this.oParams[k]
                            this.oParams[k + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k + '_time'] = dateAux.format('HH:mm')
                        } else {
                            let bFound = false
                            this.data.forEach((step) => {
                                if (step.keyname == k) {
                                    step.result = label[k]
                                    bFound = true
                                }
                            })
                            if (!bFound && typeof this.oParams[k] !== 'undefined') {
                                this.oParams[k] = label[k]
                            }
                        }
                    } else if (pType == 'aqr' && /prep_date/.test(k)) {
                        let originalKey = k
                        k = k.replace('prep_date', 'ref_prep_date')
                        if (this.oParams[k]) {
                            this.oParams[k] = label[originalKey]
                            this.oParams[originalKey] = label[originalKey]
                        }

                        if (k.includes('_timestamp')) {
                            let k_aux = k.replace('_timestamp', '')
                            let originalKey_aux = originalKey.replace('_timestamp', '')
                            let dateAux = moment(parseInt(label[originalKey_aux]) * 1000)

                            if (parseInt(label[originalKey_aux]) == label[originalKey_aux]) {
                                // CASO BARCODE LA FECHA EN LA VARIABLE ES UN TIMESTAMP
                                this.oParams[k_aux] = dateAux.format('DD/MM/YYYY HH:mm') //initial value
                            } else {
                                // LA FECHA VIENE EN EL FORMATO ESPERADO
                                this.oParams[k_aux] = label[originalKey_aux] //initial value
                            }

                            this.oParams[k] = label[originalKey] //timestamp
                            this.oParams[k_aux + '_datetime'] = this.oParams[k_aux]
                            this.oParams[k_aux + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k_aux + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k_aux + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k_aux + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k_aux + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k_aux + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k_aux + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k_aux + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k_aux + '_time'] = dateAux.format('HH:mm')
                        } else if (k.match(/ingr.{1,2}date$/gi) || k.match(/ingr.{1,2}rec$/gi)) {
                            let dateAux = moment(label[originalKey], 'DD/MM/YYYY HH:mm')
                            this.oParams[k] = label[k]
                            this.oParams[k + '_datetime'] = this.oParams[k]
                            this.oParams[k + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k + '_time'] = dateAux.format('HH:mm')
                        } else {
                            let bFound = false
                            this.data.forEach((step) => {
                                if (step.keyname == k) {
                                    step.result = label[originalKey]
                                    bFound = true
                                }
                            })
                            if (!bFound && typeof this.oParams[k] !== 'undefined') {
                                this.oParams[k] = label[originalKey]
                            }
                        }
                    } else if (pType == 'aqr' && /caducidad/.test(k)) {
                        let originalKey = k
                        k = k.replace('caducidad', 'ref_caducidad')
                        if (this.oParams[k]) {
                            this.oParams[k] = label[originalKey]
                            this.oParams[originalKey] = label[originalKey]
                        }

                        if (k.includes('_timestamp')) {
                            let k_aux = k.replace('_timestamp', '')
                            let originalKey_aux = originalKey.replace('_timestamp', '')
                            log('originalKey_aux', originalKey_aux)
                            log('label[originalKey_aux]', label[originalKey])
                            let dateAux = moment(parseInt(label[originalKey]) * 1000)

                            if (parseInt(label[originalKey_aux]) == label[originalKey_aux]) {
                                // CASO BARCODE LA FECHA EN LA VARIABLE ES UN TIMESTAMP
                                this.oParams[k_aux] = dateAux.format('DD/MM/YYYY HH:mm') //initial value
                            } else {
                                // LA FECHA VIENE EN EL FORMATO ESPERADO
                                this.oParams[k_aux] = label[originalKey_aux] //initial value
                            }

                            this.oParams[k] = label[originalKey] //timestamp
                            this.oParams[k_aux + '_datetime'] = this.oParams[k_aux]
                            this.oParams[k_aux + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k_aux + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k_aux + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k_aux + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k_aux + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k_aux + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k_aux + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k_aux + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k_aux + '_time'] = dateAux.format('HH:mm')
                        } else if (k.match(/ingr.{1,2}date$/gi) || k.match(/ingr.{1,2}rec$/gi)) {
                            let dateAux = moment(label[originalKey], 'DD/MM/YYYY HH:mm')
                            this.oParams[k] = label[k]
                            this.oParams[k + '_datetime'] = this.oParams[k]
                            this.oParams[k + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k + '_time'] = dateAux.format('HH:mm')
                        } else {
                            let bFound = false
                            this.data.forEach((step) => {
                                if (step.keyname == k) {
                                    step.result = label[originalKey]
                                    bFound = true
                                }
                            })
                            if (!bFound && typeof this.oParams[k] !== 'undefined') {
                                this.oParams[k] = label[originalKey]
                            }
                        }
                    } else if (pType == 'aqr' && /print_date/.test(k)) {
                        let originalKey = k
                        k = k.replace('print_date', 'ref_print_date')
                        if (this.oParams[k]) {
                            this.oParams[k] = label[originalKey]
                            this.oParams[originalKey] = label[originalKey]
                        }

                        if (k.includes('_timestamp')) {
                            let k_aux = k.replace('_timestamp', '')
                            let originalKey_aux = originalKey.replace('_timestamp', '')
                            log('originalKey_aux', originalKey_aux)
                            log('label[originalKey_aux]', label[originalKey])
                            let dateAux = moment(parseInt(label[originalKey]) * 1000)

                            if (parseInt(label[originalKey_aux]) == label[originalKey_aux]) {
                                // CASO BARCODE LA FECHA EN LA VARIABLE ES UN TIMESTAMP
                                this.oParams[k_aux] = dateAux.format('DD/MM/YYYY HH:mm') //initial value
                            } else {
                                // LA FECHA VIENE EN EL FORMATO ESPERADO
                                this.oParams[k_aux] = label[originalKey_aux] //initial value
                            }

                            this.oParams[k] = label[originalKey] //timestamp
                            this.oParams[k_aux + '_datetime'] = this.oParams[k_aux]
                            this.oParams[k_aux + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k_aux + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k_aux + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k_aux + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k_aux + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k_aux + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k_aux + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k_aux + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k_aux + '_time'] = dateAux.format('HH:mm')
                        } else if (k.match(/ingr.{1,2}date$/gi) || k.match(/ingr.{1,2}rec$/gi)) {
                            let dateAux = moment(label[originalKey], 'DD/MM/YYYY HH:mm')
                            this.oParams[k] = label[k]
                            this.oParams[k + '_datetime'] = this.oParams[k]
                            this.oParams[k + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k + '_time'] = dateAux.format('HH:mm')
                        } else {
                            let bFound = false
                            this.data.forEach((step) => {
                                if (step.keyname == k) {
                                    step.result = label[originalKey]
                                    bFound = true
                                }
                            })
                            if (!bFound && typeof this.oParams[k] !== 'undefined') {
                                this.oParams[k] = label[originalKey]
                            }
                        }
                    } else if (pType == 'aqr' && /^date/.test(k)) {
                        let originalKey = k
                        k = k.replace('date', 'ref_date')
                        if (this.oParams[k]) {
                            this.oParams[k] = label[originalKey]
                        }

                        if (k.includes('_timestamp')) {
                            let k_aux = k.replace('_timestamp', '')
                            let originalKey_aux = originalKey.replace('_timestamp', '')
                            let dateAux = moment(parseInt(label[originalKey_aux]) * 1000)

                            if (parseInt(label[originalKey_aux]) == label[originalKey_aux]) {
                                // CASO BARCODE LA FECHA EN LA VARIABLE ES UN TIMESTAMP
                                this.oParams[k_aux] = dateAux.format('DD/MM/YYYY HH:mm') //initial value
                            } else {
                                // LA FECHA VIENE EN EL FORMATO ESPERADO
                                this.oParams[k_aux] = label[originalKey_aux] //initial value
                            }

                            this.oParams[k] = label[originalKey] //timestamp
                            this.oParams[k_aux + '_datetime'] = this.oParams[k_aux]
                            this.oParams[k_aux + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k_aux + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k_aux + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k_aux + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k_aux + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k_aux + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k_aux + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k_aux + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k_aux + '_time'] = dateAux.format('HH:mm')
                        } else if (k.match(/ingr.{1,2}date$/gi) || k.match(/ingr.{1,2}rec$/gi)) {
                            let dateAux = moment(label[originalKey], 'DD/MM/YYYY HH:mm')
                            this.oParams[k] = label[k]
                            this.oParams[k + '_datetime'] = this.oParams[k]
                            this.oParams[k + '_d1'] = dateAux.isoWeekday() == 1 ? 'x' : ' '
                            this.oParams[k + '_d2'] = dateAux.isoWeekday() == 2 ? 'x' : ' '
                            this.oParams[k + '_d3'] = dateAux.isoWeekday() == 3 ? 'x' : ' '
                            this.oParams[k + '_d4'] = dateAux.isoWeekday() == 4 ? 'x' : ' '
                            this.oParams[k + '_d5'] = dateAux.isoWeekday() == 5 ? 'x' : ' '
                            this.oParams[k + '_d6'] = dateAux.isoWeekday() == 6 ? 'x' : ' '
                            this.oParams[k + '_d7'] = dateAux.isoWeekday() == 7 ? 'x' : ' '
                            this.oParams[k + '_day'] = dateAux.format('DD/MM/YYYY')
                            this.oParams[k + '_time'] = dateAux.format('HH:mm')
                        } else {
                            let bFound = false
                            this.data.forEach((step) => {
                                if (step.keyname == k) {
                                    step.result = label[originalKey]
                                    bFound = true
                                }
                            })
                            if (!bFound && typeof this.oParams[k] !== 'undefined') {
                                this.oParams[k] = label[originalKey]
                            }
                        }
                    }  else if (pType == 'aqr' && /^aqr/.test(k)) {
                        this.oParams['ref_aqr'] = label['aqr']
                    }
                }

                if (this.oParams['date'] && this.oParams['date'].trim() != '') {
                    const serverTimeDifference = this.$store.getters['getServerTimeDifference']
                    let currentTime = moment().add(serverTimeDifference, 'minutes')

                    if (moment(this.oParams['date'], 'DD/MM/YYYY HH:mm').isBefore(currentTime)) {
                        this.blockNextButton = true
                        this.$snackbar.error({
                            message: i18n.t('tooltip.print_invalid_date'),
                            closeable: true
                        })
                    } else {
                        this.blockNextButton = false
                    }
                }
                this.data[i].result = pType == 'aqr' ? label.aqr : true
            } else {
                this.data[i].result = result
            }
            this.data[i] = { ...this.data[i] }
            this.data = JSON.parse(JSON.stringify(this.data))
            if (this.isTemporalTimerCollection) {
                this.syncTemporalCurrentFields()
            }
            this.processAfterChanges(pType, i, result)
        },

        setProcessValue(pType, i, result) {
            this.processBeforeChanges(pType, i, result)

            this.data[i].result = result
            if (this.isTemporalTimerCollection) {
                this.syncTemporalCurrentFields()
            }

            this.processAfterChanges(pType, i, result)
        },

        processBeforeChanges(pType, i, result) {
            var hasResult = this.data[i].optional || (this.data[i].result && this.data[i].result != null && this.data[i].result != '')

            if (hasResult && this.data[i].result != result) {
                for (var k = i; k < this.data.length; k++) {
                    var datos = this.data[k]
                    if (i == 0) datos.result = '' // SOLO RESETEAMOS VALORES CUANDO HAY UN CAMBIO DE ESTADO
                    if (this.processTypes[k] == 'date' || this.processTypes[k] == 'datepast') {
                        // datos.input = {};
                    } else if (this.processTypes[k] == 'datetime') {
                        // datos.input = {};
                    } else if (this.processTypes[k] == 'time') {
                        // datos.input = {};
                    }
                }
            }
        },

        processAfterChanges(pType, i, result) {
            if (pType != 'date' && pType != 'datepast' && pType != 'string' && pType != 'datetime' && pType != 'datetimefree' && pType != 'datefree' && pType != 'time' && pType != 'number' && pType != 'barcode' && pType != 'state' && pType != 'datetimepast' && pType != 'previous_labels' && pType != 'aqr' && !this.current_template_error) {
                if (this.currentStep + 1 < this.data.length) {
                    this.currentStep++
                }
            }
            if (!this.current_template_error && (this.$mq != 'portrait' || ['barcode', 'date', 'datepast', 'datetime', 'datetimepast', 'previous_labels', 'aqr'].includes(pType))) {
                this.updatePreview(i)
            }
        },

        changeStep(goTo) {
            if (goTo == 1) {
                this.loadRelatedLabels(this.processData.selectedState.id)
                this.current_error = false
            }

            let isNext = this.currentStep + 1 == goTo
            let item = isNext ? this.data[this.currentStep] : this.data[goTo]
            log('changeStep', item)
            // SPECIAL CASES
            if (item.type == 'barcode' && item.result == '') {
                log('error barcode 0')
                this.$snackbar.error({
                    message: i18n.t('label.barcode.error_format'),
                    closeable: true
                })
            }
            // COMMON FLOW
            else if ((!this.current_template_error && !this.current_error && !this.blockNextButton) || !isNext) {
                if (item.type == 'photo' && !item.optional) {
                    //Si optional es true no es mandatory
                    const regexURL = /^https:\/\//
                    if (item.result.length == 0) {
                        this.$snackbar.warning({
                            message: i18n.t('label.error_next_step'),
                            closeable: false,
                            type: 'warning snackbar-label'
                        })
                        return
                    }
                    const validResult = item.result.every((url) => regexURL.test(url))
                    if (!validResult) {
                        this.$snackbar.warning({
                            message: i18n.t('label.error_next_step'),
                            closeable: false,
                            type: 'warning snackbar-label'
                        })
                        return
                    }
                }
                let result = item.result
                let validResult = item.optional || (result && result != null && result != '')
                let showError = validResult

                if (this.label.blocks && this.label.blocks.length > 0) {
                    let bBlockFound = false
                    this.label.blocks.forEach((block) => {
                        let blockValue = moment(block.value, 'YYYY-MM-DD').isValid() ? moment(block.value, 'YYYY-MM-DD').format('DD/MM/YYYY') : block.value
                        if (block.keyname == item.keyname && (item.result == blockValue || item.result.includes(blockValue))) {
                            bBlockFound = true
                        }
                    })

                    if (bBlockFound) {
                        validResult = false
                        this.$snackbar.error({
                            message: i18n.t('label.product_blocked'),
                            closeable: true
                        })
                    }
                }

                if (validResult) {
                    if (item.type == 'datepast') {
                        var minDate = moment(item.minDate, 'DD/MM/YYYY')
                        var maxDate = moment(item.maxDate, 'DD/MM/YYYY')
                        var date = moment(item.result, 'DD/MM/YYYY')
                        validResult = date.isBetween(minDate, maxDate) || date.isSame(minDate) || date.isSame(maxDate) || typeof item.minDate === 'undefined'

                        if (!validResult) {
                            item.result = ''
                            this.oParams[item.keyname] = ''
                            this.$snackbar.error({
                                message: i18n.t('tooltip.print_date_out_range'),
                                closeable: true
                            })
                            showError = false
                            this.updatePreview()
                        }
                    } else if (item.type == 'barcode') {
                        var format = item.rules && item.rules.vformat ? item.rules.vformat : 'DD/MM/YYYY 00:00'
                        var equal = item.rules && item.rules.equal ? true : false
                        var barcodeValue = moment(moment(item.result * 1000).format(format), 'DD/MM/YYYY HH:mm')
                        var currentTimeValue = moment(this.print_date.format(format), 'DD/MM/YYYY HH:mm')
                        // !moment(item.result * 1000).isAfter(moment())
                        showError = false
                        if (!(moment(item.result * 1000).isValid() && item.result.toString().length == 10)) {
                            log('ERROR BARCODE 1')
                            validResult = false
                            this.$snackbar.error({
                                message: i18n.t('label.barcode.error_format'),
                                closeable: true
                            })
                        } else if ((equal ? !barcodeValue.isAfter(currentTimeValue) : !barcodeValue.isSameOrAfter(currentTimeValue)) && !(item.rules && item.rules.p)) {
                            log('ERROR BARCODE 2')
                            validResult = false
                            this.$snackbar.error({
                                message: i18n.t('label.barcode.error'),
                                closeable: true
                            })
                        } else if ((equal ? barcodeValue.isAfter(currentTimeValue) : barcodeValue.isSameOrAfter(currentTimeValue)) && item.rules && !item.rules.f && item.rules.p) {
                            log('ERROR BARCODE 3', barcodeValue.isSameOrAfter(currentTimeValue), item.rules && !item.rules.f && item.rules.p)
                            validResult = false
                            this.$snackbar.error({
                                message: i18n.t('label.barcode.error'),
                                closeable: true
                            })
                        }
                    }
                }

                if (this.currentStep != goTo && goTo >= 0 && ((this.currentStep < goTo && validResult && isNext) || this.currentStep > goTo)) {
                    this.currentStep = goTo
                }

                if (!validResult && showError) {
                    this.$snackbar.error({
                        message: 'Debes indicar ' + this.data[this.currentStep].title + ' para continuar',
                        closeable: true
                    })
                } else {
                    this.updatePreview()
                }
            }
        },

        blockNext(status) {
            this.blockNextButton = status
        },

        onTemporalWizardNext() {
            if (this.currentStep < this.processTypes.length - 1) {
                this.changeStep(this.currentStep + 1)
                return
            }
            if (this.isTemporalTimerCollection && !this.isLastTemporalProduct) {
                this.goToNextTemporalProduct()
                return
            }
            this.changeStep(this.currentStep + 1)
        },

        goToNextTemporalProduct() {
            this.syncTemporalCurrentFields()
            const items = this.temporalSelectedItems
            const currentId = this.label && this.label.id
            const currentIndex = items.findIndex((item) => item && samePrintItemId(item.id, currentId))
            const nextItem = items[currentIndex + 1]
            if (!nextItem) {
                return
            }
            this.changeSelectedState({
                id: nextItem.id,
                stateID: nextItem.stateID,
                collectionID: nextItem.collectionID,
                referenceID: nextItem.referenceID
            })
            if (['portrait'].includes(this.$mq)) {
                this.bShowStates = false
            }
        },

        syncTemporalCurrentFields() {
            if (!this.isTemporalTimerCollection || !this.label) {
                return
            }

            const items = ((this.$store.getters['label/getMultiplePrint'] || {})[this.selectedCollection]) || []
            items.forEach((item) => {
                if (!item || !samePrintItemId(item.id, this.label.id)) {
                    return
                }
                this.$set(item, 'fields', JSON.parse(JSON.stringify(this.data || [])))
                this.$set(item, 'canPrint', arePrintFieldsComplete(item.fields))
            })

            const quantityStep = (this.data || []).find((step) => step.keyname === 'quantity')
            if (quantityStep) {
                this.syncTemporalListQuantity(quantityStep.result || this.label.quantity)
            }
        },

        syncTemporalListQuantity(quantity) {
            if (!this.isTemporalTimerCollection || !this.label) {
                return
            }
            const value = parseInt(quantity, 10)
            if (!Number.isFinite(value) || value < 1) {
                return
            }

            this.$set(this.label, 'quantity', value)
            this.$set(this.label, 'currentQuantity', value)
            try {
                this.$store.commit('label/referenceStateCurrentQuantity', this.label)
            } catch (error) {
                logError(error)
            }

            const items = ((this.$store.getters['label/getMultiplePrint'] || {})[this.selectedCollection]) || []
            items.forEach((item) => {
                if (item && samePrintItemId(item.id, this.label.id)) {
                    this.$set(item, 'quantity', value)
                }
            })

            const stateItem = this.states[this.iStateIndex]
            if (stateItem) {
                this.$set(stateItem, 'quantity', value)
                this.$set(stateItem, 'currentQuantity', value)
            }
        },

        print() {
            // if (!this.printerAvailable) {
            //     var oError = this.$store.getters['printer/getStatusErrorPrinter']
            //     this.$snackbar.error({ message: i18n.t(oError.msg, { s: oError.code }), closeable: true })
            //     return false
            // }
            if (this.checkingPrinter && !this.digitalState) {
                this.$snackbar.error({
                    message: i18n.t('config.printer.errors.busy2'),
                    closeable: true
                })
                return false
            }

            if (this.data[this.data.length - 1].result == '') {
                // if user does not change quantity, check if label has default value for quantity
                this.data[this.data.length - 1].result = typeof this.label.quantity !== 'undefined' && this.label.quantity ? this.label.quantity : '1'
            }

            // print labels
            this.$emit('print', { ...this })

            this.iStateCompleted++

            // only for collections
            if (this.states.length > 1) {
                // update state
                this.$store.commit('label/referenceStateCompleted', this.label)

                // update current quantity
                this.label.currentQuantity = this.data[this.data.length - 1].result
                this.$store.commit('label/referenceStateCurrentQuantity', this.label)
            }

            if (this.states.length > this.iStateCompleted) {
                let collections = this.$store.getters['label/getCollections']

                for (let key in this.states) {
                    let state = this.states[key]

                    // get first state that is not completed
                    if (!collections[state.collectionID].references[state.referenceID].states[state.stateID].completed) {
                        this.iStateIndex = key
                        break
                    }
                }
            }

            if (this.states.length <= this.iStateCompleted) {
                // this.bShowStates = false;
                // this.$emit('unselect');
                this.cancel(true)
                this.$destroy()
            } else {
                this.generateProcess()
            }
        },
        generateProcess(firstTime) {
            var firstTime = typeof firstTime !== 'undefined' ? firstTime : true

            this.$bar.reset()
            this.$bar.hide()

            var self = this
            const serverTimeDifference = self.$store.getters['getServerTimeDifference']

            this.label = { ...this.states[this.iStateIndex] }
            var label = this.label

            this.productName = this.label.name
            this.processData = {
                label: this.label,
                selectedState: { ...this.selectedState }
            }

            if (this.labelStateSelected != '' && typeof this.label.states[this.labelStateSelected] !== 'undefined') {
                self.processData.selectedState = {
                    id: this.labelStateSelected,
                    name: this.label.states[this.labelStateSelected].name,
                    digital: this.label.states[this.labelStateSelected].digital
                }
            }

            if (this.type !== 'timerproduct') {
                var selectedState =
                    self.processData && self.processData.selectedState && self.processData.selectedState.id
                        ? self.processData.selectedState
                        : {
                              id: label.states[Object.keys(label.states)[0]].id,
                              name: label.states[Object.keys(label.states)[0]].name,
                              digital: label.states[Object.keys(label.states)[0]].digital
                          }
            } else {
                var selectedState = {
                    id: label.states[Object.keys(label.states)[0]].id,
                    name: label.states[Object.keys(label.states)[0]].name,
                    digital: label.states[Object.keys(label.states)[0]].digital
                }
            }

            this.digitalState = selectedState.digital == 1

            if (this.printMode === 'printAll' && this.selectedCollection != -1) {
                selectedState.id = Object.keys(label.states)[0]
            }
            const stateToPrint = label.states && selectedState ? label.states[selectedState.id] : null
            var format = stateToPrint ? self.resolveFormatForPrint(stateToPrint.format) : null

            self.data = []
            self.processTypes = []
            self.currentStep = 0
            self.oParams = {}

            if (stateToPrint) {
                const categories = self.$store.getters['label/getCategories']
                self.oParams.category = categories[self.label.category_id] ? categories[self.label.category_id].name : ''
                Object.keys(stateToPrint).forEach((key) => {
                    if (!['digital', 'format', 'id', 'info', 'msg', 'name', 'next', 'order', 'pretime', 'time', 'priority', 'quantity', 'rel_id', 'related_state_status', 'type'].includes(key)) {
                        self.oParams[key] = stateToPrint[key]
                    }
                })
                format = self.resolveFormatForPrint(stateToPrint.format) || format
            }

            // Prepare is needed Andy Unique QR
            const parsedFormatData = parsePrintFormatData(format && format.data)
            if (!format || !parsedFormatData) {
                self.markMissingPrintFormat()
                return
            }
            self.current_template_error = false
            var data = parsedFormatData
            var isNeededAndyUniqueQR = false
            for (var i in data) {
                var step = data[i]
                if (/\[aqr\]/.test(step)) {
                    isNeededAndyUniqueQR = true
                    break
                }
            }
            if (isNeededAndyUniqueQR) {
                self.oParams['aqr'] = generateUniqueLabelId(13, this.print_date.valueOf())
            }

            if (this.type !== 'timerproduct') {
                self.processTypes.push('state')
                self.data.push({
                    tags: label.states,
                    title: i18n.t('label.popup.process.state'),
                    // message: i18n.t('label.popup.process.state_msg'),
                    result: selectedState ? selectedState.name : '',
                    selected: selectedState ? selectedState.id : '',
                    keyname: 'state'
                })
            }

            self.oParams.is_timer = this.type == 'timerproduct' ? '●' : ' '

            if (format && format.fields && Object.keys(format.fields).length > 0) {
                for (var i in format.fields) {
                    var step = format.fields[i]
                    self.processTypes.push(step.type)
                    if (step.type == 'date') {
                        var maxDate = undefined

                        // if(self.data[0].selected != '' && self.processTypes[0] == 'state'){
                        //   maxDate = moment().add(label.states[self.data[0].selected].time, 'minutes').format('D/M/YYYY');
                        // }

                        self.data.push({
                            title: step.name,
                            result: '',
                            input: {},
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: moment().add(serverTimeDifference, 'minutes').format('DD/MM/YYYY'),
                            maxDate: maxDate,
                            rules: step.rules
                        })
                    } else if (step.type == 'datepast' || step.type == 'datetimepast') {
                        var minDate = undefined
                        var maxDate = moment().add(serverTimeDifference, 'minutes').format('DD/MM/YYYY')

                        if (step.keyname == 'dflevedacao') {
                            minDate = moment().add(serverTimeDifference, 'minutes').subtract(4, 'd').format('DD/MM/YYYY')
                            maxDate = moment().add(serverTimeDifference, 'minutes').subtract(2, 'd').format('DD/MM/YYYY')
                        } else if (step.keyname == 'dftpambiente') {
                            minDate = moment().add(serverTimeDifference, 'minutes').subtract(6, 'd').format('DD/MM/YYYY')
                            maxDate = moment().add(serverTimeDifference, 'minutes').subtract(2, 'd').format('DD/MM/YYYY')
                        }

                        if (step.keyname == 'dflevedacao0') {
                            minDate = moment().add(serverTimeDifference, 'minutes').subtract(2, 'd').format('DD/MM/YYYY')
                            maxDate = moment().add(serverTimeDifference, 'minutes').subtract(0, 'd').format('DD/MM/YYYY')
                        } else if (step.keyname == 'dftpambiente0') {
                            minDate = moment().add(serverTimeDifference, 'minutes').subtract(5, 'd').format('DD/MM/YYYY')
                            maxDate = moment().add(serverTimeDifference, 'minutes').subtract(0, 'd').format('DD/MM/YYYY')
                        }

                        self.data.push({
                            title: step.name,
                            result: '',
                            input: {},
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: minDate,
                            maxDate: maxDate,
                            rules: step.rules
                        })
                    } else if (step.type == 'datetime') {
                        var maxDate = undefined

                        self.data.push({
                            title: step.name,
                            result: '',
                            date: {},
                            time: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: moment().add(serverTimeDifference, 'minutes').format('DD/MM/YYYY'),
                            maxDate: maxDate,
                            rules: step.rules
                        })
                    } else if (step.type == 'datetimefree') {
                        var maxDate = undefined
                        var minDate = undefined
                        self.data.push({
                            title: step.name,
                            result: '',
                            date: {},
                            time: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: minDate,
                            maxDate: maxDate,
                            rules: step.rules
                        })
                    } else if (step.type == 'datefree') {
                        var maxDate = undefined
                        var minDate = undefined
                        self.data.push({
                            title: step.name,
                            result: '',
                            date: {},
                            time: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: minDate,
                            maxDate: maxDate,
                            rules: step.rules
                        })
                    } else {
                        self.data.push({
                            title: step.name,
                            result: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            rules: step.rules
                        })
                    }
                }
            }
            self.processTypes.push('quantity')
            self.data.push({
                title: i18n.t('label.popup.process.quantity'),
                result: '',
                max: self.$store.getters['getMaxLabelsPrint'],
                // message: i18n.t("label.popup.process.quantity_msg"),
                keyname: 'quantity',
                optional: true
            })

            if (Object.keys(label.states).length <= 1 && this.type != 'timerproduct') {
                self.currentStep++
                // self.processTypes.shift();
            }
            // for (var o in self.data) {
            //   var dt = self.data[o];
            //
            //   if (dt.result != "" && o == 0) {
            //     self.currentStep++;
            //   } else if (dt.result != "" && self.data[o - 1].result != "") {
            //     self.currentStep++;
            //   }
            // }

            self.processData.selectedState = selectedState
            this.validatePrinterConfiguration(false)

            // only first time, move to next step if number of label states are > 1 if is equal this step is moved by if of up
            if (!this.blockNextButton && !this.current_error && Object.keys(label.states).length > 1 && this.labelStateSelected != '' && typeof this.label.states[this.labelStateSelected] !== 'undefined' && firstTime && this.type != 'timerproduct') {
                self.currentStep++
            }

            // reset selected label state
            this.labelStateSelected = ''

            // get date by timezone not from device
            let date = moment()
            if (!this.bUpdatedPrintDate) {
                try {
                    const options = {
                        timeZone: this.timezone,
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: false
                    }
                    const copy = moment(date)

                    log('1', date.format('DD/MM/YYYY HH:mm'))

                    const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                    const objectDate = {}
                    for (const item of dateTimeFormat) {
                        objectDate[item.type] = item.value
                    }
                    const dateString = `${objectDate['day'].padStart(2, '0')}/${objectDate['month'].padStart(2, '0')}/${objectDate['year']} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`
                    date = moment(dateString, 'DD/MM/YYYY HH:mm')

                    log('2', date.format('DD/MM/YYYY HH:mm'))
                    log('3', date.diff(copy, 'minutes'))
                    log('4', serverTimeDifference)

                    if (date.diff(copy, 'minutes') != serverTimeDifference) {
                        const difference = serverTimeDifference - date.diff(copy, 'minutes')
                        date = date.add(difference, 'minutes')
                    }
                } catch (error) {
                    logError(error)
                }
            }

            log(date.format('DD/MM/YYYY HH:mm'))

            this.print_date = this.bUpdatedPrintDate ? this.print_date : date
            this.init_date = date

            if (!this.current_template_error || !this.firstTime) {
                self.updatePreview()
            }
        },

        printerStoreAccessors() {
            return createPrinterStoreAccessors(this.$store)
        },

        isValidZPL(zpl) {
            const valid = isValidZplString(zpl)
            this.isAZplValid = valid
            return valid
        },

        resolveFormatForPrint(formatId) {
            return resolveFormatForPrintUtil(formatId, this.printerStoreAccessors())
        },

        extractZPLFromPrinter(format, printer) {
            return extractZPLFromPrinterUtil(format, printer, this.printerStoreAccessors())
        },

        openZplPreview({ zpl, format, labelName, params }) {
            const fields = this.newPreviewData && this.newPreviewData.fields ? this.newPreviewData.fields : null
            const state = buildZplPreviewState({ zpl, format, labelName, params, resolvedPreviewFields: fields })
            this.zpl = state.zpl
            this.density = state.density
            this.labelWidth = state.labelWidth
            this.labelHeight = state.labelHeight
            this.zplValues = state.zplValues
            this.zplParams = state.zplParams
            this.zplKey++
        },

        buildPreviewParams() {
            var product = this.label || {}
            var states = this.label && this.label.states ? this.label.states : {}
            var selState = this.processData && this.processData.selectedState && this.processData.selectedState.id != null ? this.processData.selectedState.id : null
            var stateCfg = selState != null ? states[selState] : null

            var stateName = stateCfg && stateCfg.name ? stateCfg.name : ''
            var timeMin = stateCfg && !isNaN(stateCfg.time) ? parseInt(stateCfg.time) : 0
            var prepMin = stateCfg && !isNaN(stateCfg.preptime) ? parseInt(stateCfg.preptime) : 0
            var isAnnotation = stateCfg && stateCfg.format === 'annotation'
            var msg = stateCfg && stateCfg.msg && stateCfg.msg.trim() !== '' ? stateCfg.msg : this.$t('label.preview.expired')

            var now = moment()
            var base = {
                title: stateName,
                date: isAnnotation ? msg : moment(now).add(timeMin, 'minutes').format('DD/MM/YYYY HH:mm'),
                product: product.name ? product.name : '',
                quantity: '1',
                note: product.note ? product.note : '',
                note1: stateCfg && stateCfg.info && stateCfg.info.note1 ? stateCfg.info.note1 : '',
                note2: stateCfg && stateCfg.info && stateCfg.info.note2 ? stateCfg.info.note2 : '',
                note3: stateCfg && stateCfg.info && stateCfg.info.note3 ? stateCfg.info.note3 : '',
                state: stateCfg && stateCfg.state != null && this.optionsState && this.optionsState[stateCfg.state] ? this.optionsState[stateCfg.state].name : ''
            }

            var oLocation = this.$store.getters['loginUser/getLocalLocation'] || {}
            base['account'] = oLocation && oLocation.account_name ? oLocation.account_name : ''
            base['location'] = oLocation && oLocation.name ? oLocation.name : ''
            base['city'] = oLocation && oLocation.city ? oLocation.city : ''
            base['address'] = oLocation && oLocation.address ? oLocation.address : ''
            base['loc_state'] = oLocation && oLocation.state ? oLocation.state : ''
            base['cp'] = oLocation && oLocation.cp ? oLocation.cp : ''

            return base
        },
        updatePreview() {
            var self = this
            const serverTimeDifference = this.$store.getters['getServerTimeDifference']
            this.isAZplValid = false

            var printer = Object.keys(this.$store.getters['printer/getPrinter']).length > 0 ? this.$store.getters['printer/getPrinter'] : this.$store.getters['login/getPrinter']
            var config = Object.keys(this.$store.getters['printer/getConfig']).length > 0 ? this.$store.getters['printer/getConfig'] : printer.config

            var label = this.label
            var note = label.note ? label.note : ''
            self.oParams['note'] = note
            var states = label.states ? label.states : false
            var selState = this.processData.selectedState.id ? this.processData.selectedState.id : false

            const formatId = label.states[selState] ? label.states[selState].format : null
            var format = self.resolveFormatForPrint(formatId)

            var stateMsg = label.states[selState].msg
            var stateInfo = label.states[selState].info != null && label.states[selState].info != 'null' ? label.states[selState].info : {}
            var time = states[selState] && !isNaN(states[selState].time) ? parseInt(states[selState].time) : 0
            var preptime = states[selState] && !isNaN(states[selState].preptime) ? parseInt(states[selState].preptime) : 0

            if (format) {
                var previewStructure = JSON.parse(format.preview)
                var newPreviewStructure = format.realistic_preview ? JSON.parse(format.realistic_preview) : false

                // TODO REVIEW EL GET TEMPLATE
                // var format = self.$store.getters['printer/getFormatFromTpl'](config.template_id, label.states[oProduct.selectedState.id].format);

                var formatValues = format ? JSON.parse(format.data) : []

                // --- Set de valores que ya conocemos
                self.oParams['state'] = states[selState].name
                self.next_state = states[selState].next
                var oLocation = self.$store.getters['loginUser/getLocalLocation']
                self.oParams['account'] = oLocation.account_name
                self.oParams['location'] = oLocation.name
                self.oParams['city'] = oLocation.city
                self.oParams['address'] = oLocation.address
                self.oParams['loc_state'] = oLocation.state
                self.oParams['cp'] = oLocation.cp
                self.oParams['quantity'] = self.data.length > 0 && self.data[self.data.length - 1] && self.data[self.data.length - 1].result && typeof self.data[self.data.length - 1].result === 'string' && self.data[self.data.length - 1].result.trim() != '' ? self.data[self.data.length - 1].result : 1

                for (var key in stateInfo) {
                    self.oParams[key] = stateInfo[key]
                }

                // SETTING EMPLOYEE
                var emp_id = self.$store.getters['loginUser/getLocalEmployee']

                if (emp_id) {
                    var emp = this.$store.getters['employee/getEmployee'](emp_id)
                    self.oParams['employee'] = emp.initials
                } else {
                    self.oParams['employee'] = ''
                }

                // Fecha de impresion de etiqueta
                var printDate = this.print_date
                if (self.tpRound && self.type != 'timerproduct') {
                    printDate = printDate.roundTo('minute', self.tpRound)
                }
                if (!self.autoDateCalc) {
                    self.oParams['print_date'] = printDate.format('DD/MM/YYYY HH:mm')
                    self.oParams['print_date_d1'] = printDate.isoWeekday() == 1 ? 'x' : ' '
                    self.oParams['print_date_d2'] = printDate.isoWeekday() == 2 ? 'x' : ' '
                    self.oParams['print_date_d3'] = printDate.isoWeekday() == 3 ? 'x' : ' '
                    self.oParams['print_date_d4'] = printDate.isoWeekday() == 4 ? 'x' : ' '
                    self.oParams['print_date_d5'] = printDate.isoWeekday() == 5 ? 'x' : ' '
                    self.oParams['print_date_d6'] = printDate.isoWeekday() == 6 ? 'x' : ' '
                    self.oParams['print_date_d7'] = printDate.isoWeekday() == 7 ? 'x' : ' '
                    self.oParams['print_date_day'] = printDate.format('DD/MM/YYYY')
                    self.oParams['print_date_time'] = printDate.format('HH:mm')
                    self.oParams['print_date_timestamp'] = parseInt(printDate.valueOf() / 1000).toString()
                } else {
                    self.oParams['print_date_d1'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 1 ? 'x' : ' '
                    self.oParams['print_date_d2'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 2 ? 'x' : ' '
                    self.oParams['print_date_d3'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 3 ? 'x' : ' '
                    self.oParams['print_date_d4'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 4 ? 'x' : ' '
                    self.oParams['print_date_d5'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 5 ? 'x' : ' '
                    self.oParams['print_date_d6'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 6 ? 'x' : ' '
                    self.oParams['print_date_d7'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').isoWeekday() == 7 ? 'x' : ' '
                    self.oParams['print_date_day'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')
                    self.oParams['print_date_time'] = moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').format('HH:mm')
                    self.oParams['print_date_timestamp'] = parseInt(moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm').valueOf() / 1000).toString()
                }

                var currentDay = moment(moment().add(serverTimeDifference, 'minutes').format('DD/MM/YYYY 00:00'), 'DD/MM/YYYY HH:mm')
                self.oParams['currentday'] = currentDay.format('DD/MM/YYYY 00:00')
                self.oParams['currentday_day'] = currentDay.format('DD/MM/YYYY')
                self.oParams['currentday_time'] = currentDay.format('00:00')
                self.oParams['currentday_timestamp'] = parseInt(currentDay.valueOf() / 1000).toString()
                self.oParams['currentday_d1'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 1 ? 'x' : ' '
                self.oParams['currentday_d2'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 2 ? 'x' : ' '
                self.oParams['currentday_d3'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 3 ? 'x' : ' '
                self.oParams['currentday_d4'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 4 ? 'x' : ' '
                self.oParams['currentday_d5'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 5 ? 'x' : ' '
                self.oParams['currentday_d6'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 6 ? 'x' : ' '
                self.oParams['currentday_d7'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').isoWeekday() == 7 ? 'x' : ' '
                self.oParams['currentday_day'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')
                self.oParams['currentday_time'] = moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').format('HH:mm')
                self.oParams['currentday_timestamp'] = parseInt(moment(self.oParams['currentday'], 'DD/MM/YYYY HH:mm').valueOf() / 1000).toString()

                var currentTime = moment(moment().add(serverTimeDifference, 'minutes').format('DD/MM/YYYY HH:mm'), 'DD/MM/YYYY HH:mm')
                self.oParams['currenttime'] = currentTime.format('DD/MM/YYYY HH:mm')
                self.oParams['currenttime_day'] = currentTime.format('DD/MM/YYYY')
                self.oParams['currenttime_time'] = currentTime.format('HH:mm')
                self.oParams['currenttime_timestamp'] = parseInt(currentTime.valueOf() / 1000).toString()

                // Fecha de cáculo de caducidades
                var initDate = self.oParams['initdate'] && !self.bUpdatedPrintDate ? moment(self.oParams['initdate'], 'DD/MM/YYYY HH:mm') : !self.autoDateCalc ? printDate : moment(self.oParams['print_date'], 'DD/MM/YYYY HH:mm')

                // Caducidad secundaria
                const cad2a = self.formatTimeToMax(time)
                let aux = !self.autoDateCalc ? moment(initDate).add(cad2a.result, cad2a.format) : moment(self.oParams['date'], 'DD/MM/YYYY HH:mm') // Print date + time
                if (self.tpRound && self.type != 'timerproduct') {
                    aux = aux.roundTo('minute', self.tpRound)
                }
                if (self.oParams['ref_date'] && aux.valueOf() > moment(self.oParams['ref_date'], 'DD/MM/YYYY HH:mm').valueOf()) {
                    aux = moment(self.oParams['ref_date'], 'DD/MM/YYYY HH:mm')
                }
                self.oParams['date'] = aux.format('DD/MM/YYYY HH:mm')
                self.oParams['date_day'] = aux.format('DD/MM/YYYY')
                self.oParams['date_time'] = aux.format('HH:mm')
                self.oParams['date_timestamp'] = parseInt(aux.valueOf() / 1000).toString()

                self.oParams['date_raw'] = aux.format('DD/MM/YYYY HH:mm')
                self.oParams['date_raw_day'] = aux.format('DD/MM/YYYY')
                self.oParams['date_raw_time'] = aux.format('HH:mm')
                self.oParams['date_raw_timestamp'] = parseInt(aux.valueOf() / 1000).toString()
                self.oParams['date_d1'] = aux.isoWeekday() == 1 ? 'x' : ' '
                self.oParams['date_d2'] = aux.isoWeekday() == 2 ? 'x' : ' '
                self.oParams['date_d3'] = aux.isoWeekday() == 3 ? 'x' : ' '
                self.oParams['date_d4'] = aux.isoWeekday() == 4 ? 'x' : ' '
                self.oParams['date_d5'] = aux.isoWeekday() == 5 ? 'x' : ' '
                self.oParams['date_d6'] = aux.isoWeekday() == 6 ? 'x' : ' '
                self.oParams['date_d7'] = aux.isoWeekday() == 7 ? 'x' : ' '

                // Caducidad de preparacion (?)
                const freezingTime = self.formatTimeToMax(preptime)
                aux = moment(initDate).add(freezingTime.result, freezingTime.format) // Print date + preptime
                if (self.tpRound && self.type != 'timerproduct') {
                    aux = aux.roundTo('minute', self.tpRound)
                }
                if (self.oParams['ref_prep_date'] && aux.valueOf() < moment(self.oParams['ref_prep_date'], 'DD/MM/YYYY HH:mm').valueOf()) {
                    aux = moment(self.oParams['ref_prep_date'], 'DD/MM/YYYY HH:mm')
                }
                self.oParams['prep_date'] = aux.format('DD/MM/YYYY HH:mm')
                self.oParams['prep_date_day'] = aux.format('DD/MM/YYYY')
                self.oParams['prep_date_time'] = aux.format('HH:mm')
                self.oParams['prep_date_timestamp'] = parseInt(aux.valueOf() / 1000).toString()

                // --- Set de valores que han de ser calculados pero que no los introduce
                //     el usuario, por tanto no estan en el process de por si
                for (var field in formatValues) {
                    var value = formatValues[field]

                    // si son formatValues y estan entre [ ]
                    const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                    let m

                    while ((m = regex.exec(value)) !== null) {
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                            regex.lastIndex++
                        }

                        // The result can be accessed through the `m`-variable.
                        m.forEach((match, groupIndex) => {
                            match = match.replace(/[\{\}\[\]]/gi, '')
                            if (match != '' && !Object.keys(self.oParams).includes(match)) {
                                self.oParams[match] = ''
                            }
                        })
                    }
                }

                // --- Format data from process, and create auxiliary info (date_da, date_time...)
                var oProcess = JSON.parse(JSON.stringify(self.data))
                var bCaducidadIsBarcode = false
                for (var i in oProcess) {
                    var step = oProcess[i]
                    if (step.keyname == 'quantity') {
                        self.oParams[step.keyname] = step.result != '' ? step.result : '1'
                        self.num_copies = step.result != '' ? parseInt(step.result) : 1
                    } else if (step.type == 'date' || step.type == 'datetime' || step.type == 'datepast' || step.type == 'datetimefree' || step.type == 'datefree' || step.type == 'barcode' || step.type == 'datetimepast') {
                        if ((step.type == 'datetime' || step.type == 'datetimefree' || step.type == 'datefree' || step.type == 'datetimepast') && step.result && step.result.trim() !== '') {
                            step.result = moment(step.result, 'DD/MM/YYYY HH:mm')
                        } else if (step.type == 'barcode') {
                            if (step.keyname == 'caducidad') bCaducidadIsBarcode = true

                            if (step.result && step.result.trim() !== '') {
                                self.oParams[step.keyname] = step.result
                                if (step.result.toString().length == 10) {
                                    step.result = moment(step.result * 1000)
                                } else {
                                    step.result = moment(false)
                                }
                            }
                        } else if (step.result && step.result.trim() !== '') {
                            // TODO CHECK IF THIS IS CORRECT
                            step.result = moment(step.result, 'DD/MM/YYYY HH:mm').endOf('day')
                            // step.result = moment(step.result, 'DD/MM/YYYY HH:mm')
                        }

                        // We create different variables (date, date_day...)
                        let aux = step.result
                        if (aux && aux.isValid()) {
                            if (step.type !== 'barcode') self.oParams[step.keyname] = aux.format('DD/MM/YYYY HH:mm')
                            else self.oParams[step.keyname + '_datetime'] = aux.format('DD/MM/YYYY HH:mm')

                            self.oParams[step.keyname + '_day'] = aux.format('DD/MM/YYYY')
                            self.oParams[step.keyname + '_time'] = aux.format('HH:mm')
                            self.oParams[step.keyname + '_timestamp'] = parseInt(aux.valueOf() / 1000).toString()
                            self.oParams[step.keyname + '_d1'] = aux.isoWeekday() == 1 ? 'x' : ' '
                            self.oParams[step.keyname + '_d2'] = aux.isoWeekday() == 2 ? 'x' : ' '
                            self.oParams[step.keyname + '_d3'] = aux.isoWeekday() == 3 ? 'x' : ' '
                            self.oParams[step.keyname + '_d4'] = aux.isoWeekday() == 4 ? 'x' : ' '
                            self.oParams[step.keyname + '_d5'] = aux.isoWeekday() == 5 ? 'x' : ' '
                            self.oParams[step.keyname + '_d6'] = aux.isoWeekday() == 6 ? 'x' : ' '
                            self.oParams[step.keyname + '_d7'] = aux.isoWeekday() == 7 ? 'x' : ' '

                            for (let i = 0; i < 4; i++) {
                                let day = i18n.t('calendar.days')[aux.day()].toUpperCase()
                                if (i > 0) {
                                    self.oParams[step.keyname + '_wd' + i] = day.slice(0, i)
                                } else {
                                    self.oParams[step.keyname + '_wd'] = day
                                }
                            }
                        } else if (!self.autoDateCalc) {
                            if (step.type !== 'barcode' || step.result == '') self.oParams[step.keyname] = ''
                            else self.oParams[step.keyname + '_datetime'] = ''

                            self.oParams[step.keyname + '_day'] = ''
                            self.oParams[step.keyname + '_time'] = ''
                            self.oParams[step.keyname + '_timestamp'] = ''
                            self.oParams[step.keyname + '_d1'] = ' '
                            self.oParams[step.keyname + '_d2'] = ' '
                            self.oParams[step.keyname + '_d3'] = ' '
                            self.oParams[step.keyname + '_d4'] = ' '
                            self.oParams[step.keyname + '_d5'] = ' '
                            self.oParams[step.keyname + '_d6'] = ' '
                            self.oParams[step.keyname + '_d7'] = ' '

                            for (let i = 0; i < 4; i++) {
                                if (i > 0) {
                                    self.oParams[step.keyname + '_wd' + i] = ' '
                                } else {
                                    self.oParams[step.keyname + '_wd'] = ' '
                                }
                            }
                        }
                    } else if (step.keyname == 'amasada') {
                        self.oParams['num_amasada'] = 1
                        self.oParams[step.keyname] = step.result
                    } else {
                        // We set any other value in their position and result
                        if (step.keyname != 'state') {
                            self.oParams[step.keyname] = step.result
                        }
                    }
                }

                // --- Se calculan las caducidades y se hacen las debidas validaciones

                // Auxiliary vars
                let cadPrimaria = false
                if (bCaducidadIsBarcode) {
                    cadPrimaria = self.oParams['caducidad'] && self.oParams['caducidad_datetime'] ? moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm') : false
                } else {
                    cadPrimaria = self.oParams['caducidad'] && moment(self.oParams['caducidad'], 'DD/MM/YYYY HH:mm').isValid() ? moment(self.oParams['caducidad'], 'DD/MM/YYYY HH:mm') : false
                }

                if (cadPrimaria) {
                    self.oParams['caducidad_day'] = cadPrimaria.format('DD/MM/YYYY')
                    self.oParams['caducidad_time'] = cadPrimaria.format('HH:mm')
                    self.oParams['caducidad_timestamp'] = parseInt(cadPrimaria.valueOf() / 1000).toString()
                } else if (!bCaducidadIsBarcode) {
                    self.oParams['caducidad'] = ''
                    self.oParams['caducidad_day'] = ''
                    self.oParams['caducidad_time'] = ''
                    self.oParams['caducidad_timestamp'] = ''
                }

                // let cadSecundaria = moment(self.oParams['date']);
                // let cadPreparacion = moment(self.oParams['prep_date']);
                let cadSecundaria = moment(self.oParams['date'], 'DD/MM/YYYY HH:mm')
                let cadPreparacion = moment(self.oParams['prep_date'], 'DD/MM/YYYY HH:mm')

                // Si el producto caduca antes que la cad. secundaria, ponemos la cad primaria como caducidad
                if (cadPrimaria && cadPrimaria.isBefore(cadSecundaria)) {
                    self.oParams['date'] = cadPrimaria.format('DD/MM/YYYY HH:mm')
                    self.oParams['date_day'] = cadPrimaria.format('DD/MM/YYYY')
                    self.oParams['date_time'] = cadPrimaria.format('HH:mm')
                    self.oParams['date_timestamp'] = parseInt(cadPrimaria.valueOf() / 1000).toString()
                }
                // Lo mismo con el preptime
                if (cadPrimaria && cadPrimaria.isBefore(cadPreparacion)) {
                    self.oParams['date'] = cadPrimaria.format('DD/MM/YYYY HH:mm')
                    self.oParams['date_day'] = cadPrimaria.format('DD/MM/YYYY')
                    self.oParams['date_time'] = cadPrimaria.format('HH:mm')
                    self.oParams['date_timestamp'] = parseInt(cadPrimaria.valueOf() / 1000).toString()

                    // No tiene sentido un t. de preparacion si ya ha caducado, asi que lo quitamos
                    // self.oParams['prep_date'] = '-'
                    // self.oParams['prep_date_day'] = '-'
                    // self.oParams['prep_date_time'] = '-'

                    self.$snackbar.error({
                        message: i18n.t('tooltip.print_invalid_date'),
                        closeable: true
                    })
                    self.current_error = true
                } else {
                    self.current_error = false
                }

                // It only applies at next state
                // Si la cad. secundaria calculada es anterior a la fecha de impresion, es que ha caducado

                // console.error('initDate', initDate.format('DD/MM/YYYY HH:mm'))
                // console.error('cadSecundaria', cadSecundaria.format('DD/MM/YYYY HH:mm'))
                if (cadSecundaria.isSameOrBefore(initDate) || cadSecundaria.isSameOrBefore(currentTime)) {
                    self.oParams['date'] = self.$t('label.expired')
                    self.oParams['date_day'] = self.$t('label.expired')
                    self.oParams['date_time'] = '--'
                    self.oParams['date_timestamp'] = ''
                }

                // Si el estado tiene un mensaje definido, lo mostramos
                if (stateMsg) {
                    self.oParams['date'] = stateMsg
                    self.oParams['date_day'] = stateMsg
                    self.oParams['date_time'] = '--'
                    self.oParams['date_timestmap'] = ''
                }

                // --- Calc de valores custom de cada restaurante
                for (var key in self.oParams) {
                    var val = self.oParams[key]
                    let keyUsoDate = false
                    if (key.match(/usodate/)) {
                        keyUsoDate = key
                        key = 'usodate'
                    }
                    switch (key) {
                        // PIZZA HUT HACK -----------------------
                        case 'cad_sec_mesa':
                        case 'cad_sec_mesa1':
                            if (initDate.isSame(cadPrimaria, 'day')) {
                                self.oParams[key] = cadPrimaria.format('DD/MM/YYYY HH:mm')
                            } else {
                                self.oParams[key] = initDate.format('DD/MM/YYYY') + i18n.t('label.print.config.close_day')
                            }
                            break

                        case 'cad_sec_mesa2':
                            if (cadSecundaria.isSame(cadPrimaria, 'day') || cadSecundaria.isAfter(cadPrimaria, 'day')) {
                                self.oParams[key] = cadPrimaria.format('DD/MM/YYYY HH:mm')
                            } else {
                                self.oParams[key] = cadSecundaria.format('DD/MM/YYYY') + i18n.t('label.print.config.close_day')
                            }
                            break
                        case 'cierre_today_or_day':
                            if (cadSecundaria.isSame(initDate, 'day')) {
                                self.oParams[key] = i18n.t('label.print.config.close_day')
                            } else {
                                self.oParams[key] = cadSecundaria.format('DD/MM/YYYY HH:mm')
                            }
                            break
                        case 'caducidad2': //SALSA TOMATE - CADUCIDAD 1ª ESPECIAS
                            var stepCad2 = self.data.filter((step) => {
                                return step.keyname == 'caducidad2'
                            })
                            stepCad2 = stepCad2[0] ? stepCad2[0] : false
                            let caducidad2 = stepCad2 && stepCad2.type == 'barcode' ? moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm') : moment(self.oParams['caducidad2'], 'DD/MM/YYYY HH:mm')
                            if (cadPrimaria.valueOf() > caducidad2.valueOf() && (caducidad2.valueOf() < cadSecundaria.valueOf() || (stateMsg && caducidad2.valueOf() < moment(cadSecundaria.format('DD/MM/YYYY 23:59'), 'DD/MM/YYYY HH:mm').valueOf()))) {
                                cadSecundaria = caducidad2
                                self.oParams['date'] = caducidad2.format('DD/MM/YYYY HH:mm')
                                self.oParams['date_day'] = caducidad2.format('DD/MM/YYYY')
                                self.oParams['date_time'] = caducidad2.format('HH:mm')
                                self.oParams['date_timestamp'] = parseInt(caducidad2.valueOf() / 1000).toString()
                            }
                            if (cadPrimaria && cadPrimaria.isValid() && caducidad2.isValid() && stepCad2.rules && stepCad2.rules.o && stepCad2.rules.pa && stepCad2.rules.v && self.oParams[stepCad2.rules.pa]) {
                                let date_compare = moment()
                                switch (stepCad2.rules.v) {
                                    case 'end_day':
                                        date_compare = moment(printDate.format('DD/MM/YYYY 23:59'), 'DD/MM/YYYY HH:mm')
                                        break

                                    default:
                                        break
                                }
                                switch (stepCad2.rules.o) {
                                    case '<':
                                        self.oParams['caducidad2'] = caducidad2.isBefore(date_compare) ? self.oParams[stepCad2.rules.pa] : caducidad2.format(stepCad2.rules.vformat)
                                        break
                                    case '<=':
                                        self.oParams['caducidad2'] = caducidad2.isSameOrBefore(date_compare) ? self.oParams[stepCad2.rules.pa] : caducidad2.format(stepCad2.rules.vformat)
                                        break
                                    case '>':
                                        self.oParams['caducidad2'] = caducidad2.isAfter(date_compare) ? self.oParams[stepCad2.rules.pa] : caducidad2.format(stepCad2.rules.vformat)
                                        break
                                    case '>=':
                                        self.oParams['caducidad2'] = caducidad2.isSameOrAfter(date_compare) ? self.oParams[stepCad2.rules.pa] : caducidad2.format(stepCad2.rules.vformat)
                                        break
                                }
                            }
                            break
                        // PIZZA HUT HACK -----------------------
                        case 'df_lev_massa_day':
                            if (moment(self.oParams['dflevedacao'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dflevedacao'], 'DD/MM/YYYY')
                                let dfMassa = [false, false, 3, 2, 1, false, false]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_lev_massa = moment(initDate).add(dfMassa[diff], 'h')

                                self.oParams['df_lev_massa_day'] = df_lev_massa.format('DD/MM/YYYY')
                                self.oParams['df_lev_massa_time'] = df_lev_massa.format('HH:mm')
                                self.oParams['df_lev_massa_timestamp'] = parseInt(df_lev_massa.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_lev_massa_day'] = ''
                                self.oParams['df_lev_massa_time'] = ''
                                self.oParams['df_lev_massa_timestamp'] = ''
                            }
                            break
                        case 'df_lev_sides_day':
                            if (moment(self.oParams['dflevedacao'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dflevedacao'], 'DD/MM/YYYY')
                                let dfMassa = [false, false, 3, 2, 1, false, false]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_lev_sides = moment(initDate).add(dfMassa[diff], 'h')

                                self.oParams['df_lev_sides_day'] = df_lev_sides.format('DD/MM/YYYY')
                                self.oParams['df_lev_sides_time'] = df_lev_sides.format('HH:mm')
                                self.oParams['df_lev_sides_timestamp'] = parseInt(df_lev_sides.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_lev_sides_day'] = ''
                                self.oParams['df_lev_sides_time'] = ''
                                self.oParams['df_lev_sides_timestamp'] = ''
                            }
                            break
                        case 'df_ta_massa_day':
                            if (moment(self.oParams['dftpambiente'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dftpambiente'], 'DD/MM/YYYY')
                                let dfMassa = [false, false, 4, 3, 2, 1, 0.5]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_ta_massa = moment(initDate).add(dfMassa[diff], 'h')
                                log(diff, dfMassa[diff], initDate)

                                self.oParams['df_ta_massa_day'] = df_ta_massa.format('DD/MM/YYYY')
                                self.oParams['df_ta_massa_time'] = df_ta_massa.format('HH:mm')
                                self.oParams['df_ta_massa_timestamp'] = parseInt(df_ta_massa.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_ta_massa_day'] = ''
                                self.oParams['df_ta_massa_time'] = ''
                                self.oParams['df_ta_massa_timestamp'] = ''
                            }
                            break
                        case 'df_ta_sides_day':
                            if (moment(self.oParams['dftpambiente'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dftpambiente'], 'DD/MM/YYYY')
                                let dfMassa = [false, false, 2, 1.5, 1, 0.5, 0.25]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_ta_sides = moment(initDate).add(dfMassa[diff], 'h')

                                self.oParams['df_ta_sides_day'] = df_ta_sides.format('DD/MM/YYYY')
                                self.oParams['df_ta_sides_time'] = df_ta_sides.format('HH:mm')
                                self.oParams['df_ta_sides_timestamp'] = parseInt(df_ta_sides.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_ta_sides_day'] = ''
                                self.oParams['df_ta_sides_time'] = ''
                                self.oParams['df_ta_sides_timestamp'] = ''
                            }
                            break
                        case 'df_lev_pan_day':
                            if (moment(self.oParams['dflevedacao0'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dflevedacao0'], 'DD/MM/YYYY')
                                let dfMassa = [2.5, 1.5, 1, false, false, false, false]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_lev_pan = moment(initDate).add(dfMassa[diff], 'h')

                                self.oParams['df_lev_pan_day'] = df_lev_pan.format('DD/MM/YYYY')
                                self.oParams['df_lev_pan_time'] = df_lev_pan.format('HH:mm')
                                self.oParams['df_lev_pan_timestamp'] = parseInt(df_lev_pan.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_lev_pan_day'] = ''
                                self.oParams['df_lev_pan_time'] = ''
                                self.oParams['df_lev_pan_timestamp'] = ''
                            }
                            break
                        case 'df_ta_pan_day':
                            if (moment(self.oParams['dftpambiente0'], 'DD/MM/YYYY').isValid()) {
                                let df = moment(self.oParams['dftpambiente0'], 'DD/MM/YYYY')
                                let dfMassa = [4, 4, 3, 3, 2, 2, false]
                                let diff = moment(initDate).diff(df, 'days')
                                let df_ta_pan = moment(initDate).add(dfMassa[diff], 'h')

                                self.oParams['df_ta_pan_day'] = df_ta_pan.format('DD/MM/YYYY')
                                self.oParams['df_ta_pan_time'] = df_ta_pan.format('HH:mm')
                                self.oParams['df_ta_pan_timestamp'] = parseInt(df_ta_pan.valueOf() / 1000).toString()
                            } else {
                                self.oParams['df_ta_pan_day'] = ''
                                self.oParams['df_ta_pan_time'] = ''
                                self.oParams['df_ta_pan_timestamp'] = ''
                            }
                            break
                        case 'usodate':
                            if ((self.oParams['caducidad_datetime'] && self.oParams['caducidad_datetime'] != '' && self.oParams['caducidad2_datetime'] && self.oParams['caducidad2_datetime'] != '') || (!cadPrimaria && self.oParams['caducidad2_datetime'] && self.oParams['caducidad2_datetime'] != '')) {
                                if (self.oParams['caducidad2_datetime'] && self.oParams['caducidad2_datetime'] != '') {
                                    self.oParams[keyUsoDate] = moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm').add(preptime, 'minutes').format('DD/MM/YYYY HH:mm')
                                } else {
                                    self.oParams[keyUsoDate] = moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm').add(preptime, 'minutes').format('DD/MM/YYYY HH:mm')
                                }
                            } else if (self.oParams['caducidad_datetime'] && typeof self.oParams['caducidad2'] == 'undefined' && self.oParams[keyUsoDate] == '') {
                                self.oParams[keyUsoDate] = moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm').add(preptime, 'minutes').format('DD/MM/YYYY HH:mm')
                            } else if (self.oParams[keyUsoDate] != '' && (self.oParams['caducidad_datetime'] == '' || self.oParams['caducidad2_datetime'] == '')) {
                                self.oParams[keyUsoDate] = ''
                            }

                            if (self.oParams[keyUsoDate] != '') {
                                var alseaCad2Calc = moment(printDate.valueOf())
                                var bDateModify = false
                                if (time == 0 && stateMsg != '' && stateMsg != null) {
                                    alseaCad2Calc = moment(alseaCad2Calc.format('DD/MM/YYYY') + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss')
                                    if (alseaCad2Calc.isAfter(moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm'))) {
                                        alseaCad2Calc = moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm')
                                        bDateModify = true
                                    }
                                    if (self.oParams['caducidad_datetime'] && self.oParams['caducidad_datetime'] != '' && alseaCad2Calc.isAfter(moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm'))) {
                                        alseaCad2Calc = moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm')
                                        bDateModify = true
                                    }

                                    self.oParams['a_date_calc'] = !bDateModify ? stateMsg : alseaCad2Calc.format('DD/MM/YYYY HH:mm')
                                    self.oParams['a_date_calc_day'] = alseaCad2Calc.format('DD/MM/YYYY')
                                    self.oParams['a_date_calc_time'] = alseaCad2Calc.format('HH:mm')
                                    self.oParams['a_date_calc_timestamp'] = parseInt(alseaCad2Calc.valueOf() / 1000).toString()
                                    self.oParams['a_date_calc_d1'] = alseaCad2Calc.isoWeekday() == 1 ? 'x' : ' '
                                    self.oParams['a_date_calc_d2'] = alseaCad2Calc.isoWeekday() == 2 ? 'x' : ' '
                                    self.oParams['a_date_calc_d3'] = alseaCad2Calc.isoWeekday() == 3 ? 'x' : ' '
                                    self.oParams['a_date_calc_d4'] = alseaCad2Calc.isoWeekday() == 4 ? 'x' : ' '
                                    self.oParams['a_date_calc_d5'] = alseaCad2Calc.isoWeekday() == 5 ? 'x' : ' '
                                    self.oParams['a_date_calc_d6'] = alseaCad2Calc.isoWeekday() == 6 ? 'x' : ' '
                                    self.oParams['a_date_calc_d7'] = alseaCad2Calc.isoWeekday() == 7 ? 'x' : ' '
                                } else {
                                    const alcad2a = self.formatTimeToMax(time)
                                    alseaCad2Calc = alseaCad2Calc.add(alcad2a.result, alcad2a.format)

                                    if (alseaCad2Calc.isAfter(moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm'))) {
                                        alseaCad2Calc = moment(self.oParams['caducidad2_datetime'], 'DD/MM/YYYY HH:mm')
                                    }
                                    if (alseaCad2Calc.isAfter(moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm'))) {
                                        alseaCad2Calc = moment(self.oParams['caducidad_datetime'], 'DD/MM/YYYY HH:mm')
                                    }
                                    self.oParams['a_date_calc'] = alseaCad2Calc.format('DD/MM/YYYY HH:mm')
                                    self.oParams['a_date_calc_day'] = alseaCad2Calc.format('DD/MM/YYYY')
                                    self.oParams['a_date_calc_time'] = alseaCad2Calc.format('HH:mm')
                                    self.oParams['a_date_calc_timestamp'] = parseInt(alseaCad2Calc.valueOf() / 1000).toString()
                                    self.oParams['a_date_calc_d1'] = alseaCad2Calc.isoWeekday() == 1 ? 'x' : ' '
                                    self.oParams['a_date_calc_d2'] = alseaCad2Calc.isoWeekday() == 2 ? 'x' : ' '
                                    self.oParams['a_date_calc_d3'] = alseaCad2Calc.isoWeekday() == 3 ? 'x' : ' '
                                    self.oParams['a_date_calc_d4'] = alseaCad2Calc.isoWeekday() == 4 ? 'x' : ' '
                                    self.oParams['a_date_calc_d5'] = alseaCad2Calc.isoWeekday() == 5 ? 'x' : ' '
                                    self.oParams['a_date_calc_d6'] = alseaCad2Calc.isoWeekday() == 6 ? 'x' : ' '
                                    self.oParams['a_date_calc_d7'] = alseaCad2Calc.isoWeekday() == 7 ? 'x' : ' '
                                }

                                let iMarginTime = keyUsoDate.replace('usodate', '')
                                let bInMarginTime = true
                                if (iMarginTime != '') {
                                    bInMarginTime = printDate.isBefore(moment(self.oParams[keyUsoDate], 'DD/MM/YYYY HH:mm').add(iMarginTime, 'minutes'))
                                }

                                if (printDate.isBefore(moment(self.oParams[keyUsoDate], 'DD/MM/YYYY HH:mm')) || !bInMarginTime || (bDateModify && printDate.isAfter(alseaCad2Calc)) || alseaCad2Calc.isBefore(printDate)) {
                                    self.$snackbar.error({
                                        message: i18n.t('tooltip.print_date_out_range'),
                                        closeable: true
                                    })
                                    self.current_error = true
                                }
                            } else {
                                self.oParams['a_date_calc'] = ''
                                self.oParams['a_date_calc_day'] = ''
                                self.oParams['a_date_calc_time'] = ''
                                self.oParams['a_date_calc_timestamp'] = ''
                                self.oParams['a_date_calc_d1'] = ' '
                                self.oParams['a_date_calc_d2'] = ' '
                                self.oParams['a_date_calc_d3'] = ' '
                                self.oParams['a_date_calc_d4'] = ' '
                                self.oParams['a_date_calc_d5'] = ' '
                                self.oParams['a_date_calc_d6'] = ' '
                                self.oParams['a_date_calc_d7'] = ' '
                            }
                            break
                        default:
                            if (key.match(/ingr.{1,2}date$/gi) && self.oParams[key] != '') {
                                let caducidadIngr = moment(self.oParams[key], 'DD/MM/YYYY HH:mm')
                                if (caducidadIngr.isBefore(printDate)) {
                                    self.$snackbar.error({
                                        message: i18n.t('tooltip.print_date_out_range'),
                                        closeable: true
                                    })
                                    self.current_error = true
                                } else if ((cadPrimaria.valueOf() > caducidadIngr.valueOf() || !cadPrimaria) && caducidadIngr.valueOf() < cadSecundaria.valueOf()) {
                                    cadSecundaria = caducidadIngr
                                    self.oParams['date'] = caducidadIngr.format('DD/MM/YYYY HH:mm')
                                    self.oParams['date_day'] = caducidadIngr.format('DD/MM/YYYY')
                                    self.oParams['date_time'] = caducidadIngr.format('HH:mm')
                                    self.oParams['date_timestamp'] = parseInt(caducidadIngr.valueOf() / 1000).toString()
                                }
                            }
                            break
                    }
                }

                let dateParams = ['print_date', 'currentday', 'currenttime', 'date', 'prep_date']
                dateParams.forEach((date) => {
                    for (let i = 0; i < 4; i++) {
                        aux = moment(self.oParams[date], 'DD/MM/YYYY HH:mm')
                        if (aux.isValid()) {
                            let day = i18n.t('calendar.days')[aux.day()].toUpperCase()
                            if (i > 0) {
                                self.oParams[date + '_wd' + i] = day.slice(0, i)
                            } else {
                                self.oParams[date + '_wd'] = day
                            }
                        } else {
                            // IN CASE INVALID DATE, GENERATE DAY INFO WITH CURRENT DAY
                            let day = i18n.t('calendar.days')[moment().day()].toUpperCase()
                            if (i > 0) {
                                self.oParams[date + '_wd' + i] = day.slice(0, i)
                            } else {
                                self.oParams[date + '_wd'] = day
                            }
                        }
                    }
                })

                self.oParams['product'] = self.label.name

                // --- Seteamos los datos que iran al template de la etiqueta
                self.printData = []
                for (var field in formatValues) {
                    var value = formatValues[field]

                    if (value) {
                        let aux = value

                        let start = aux.indexOf('[') > -1 ? aux.indexOf('[') : aux.indexOf('{')
                        start++
                        let end = aux.indexOf(']') > -1 ? aux.indexOf(']') : aux.indexOf('}')
                        let keyValue = aux.substring(start, end)
                        let oldKeyValue = aux.substring(start, end)

                        if (keyValue) {
                            keyValue = keyValue.replace('[', '').replace(']', '').replace('{', '').replace('}', '')
                            aux = aux.replace('[', '').replace(']', '').replace('{', '').replace('}', '')

                            if (!self.oParams[keyValue]) {
                                self.oParams[keyValue] = aux
                            }
                            let newValue = cleanString(self.oParams[keyValue])
                            if (newValue.indexOf(oldKeyValue) != -1) {
                                // if (newValue == oldKeyValue || aux == newValue) {
                                newValue = '' //newValue.replace(oldKeyValue, '')
                                self.oParams[keyValue] = newValue
                            }
                            aux = aux.replace(keyValue, newValue)
                        }

                        // if print date is updated, update preview

                        if (['print_date', 'print_date_time', 'print_date_day'].includes(keyValue) && self.bUpdatedPrintDate) {
                            aux += ' *'
                            self.calculate += 1
                        }

                        self.printData.push({ k: field, v: cleanString(aux) })
                    } else {
                        self.printData.push({ k: field, v: '' })
                    }
                }

                // -- Mostraremos en el preview los mismos valores que se quieren imprimir
                let preview = {}
                for (var field in formatValues) {
                    var value = formatValues[field]

                    if (value.indexOf('[') != -1) {
                        let start = value.indexOf('[')
                        let end = value.indexOf(']')
                        let keyValue = value.substring(start, end).replace('[', '').replace(']', '')

                        let name = self.$t('label.preview.' + keyValue)
                        if (name.indexOf('label.preview.') != -1) {
                            name = keyValue
                        }

                        if (keyValue != '' && !Object.keys(preview).includes(keyValue) && Object.keys(self.oParams).includes(keyValue)) {
                            preview[keyValue] = {
                                label: name,
                                value: self.oParams[keyValue]
                            }
                        }
                    }
                }

                var currentLength = 4
                var currentRow = -1
                var values = JSON.parse(format.data)

                self.previewPrint = []
                previewStructure.forEach((el) => {
                    let key = el[0]
                    let length = el[1]
                    if (currentLength + length > 4) {
                        currentRow++
                        currentLength = 0
                        self.previewPrint[currentRow] = []
                    }
                    if (values[key].match(/[\{\}\[\]]/gi)) {
                        const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                        var val = values[key]
                        var value = val
                        let m
                        var index = ''
                        while ((m = regex.exec(val)) !== null) {
                            // This is necessary to avoid infinite loops with zero-width matches
                            if (m.index === regex.lastIndex) {
                                regex.lastIndex++
                            }

                            // The result can be accessed through the `m`-variable.
                            m.forEach((match, groupIndex) => {
                                index = match.replace(/[\{\}\[\]]/gi, '')
                                value = value.replace(match, self.oParams[index])

                                if (['print_date', 'print_date_time', 'print_date_day'].includes(index) && self.bUpdatedPrintDateVisible) {
                                    value += ' *'
                                }
                            })
                        }

                        var currentStep = self.data.filter((step) => {
                            return step.keyname == index
                        })

                        self.previewPrint[currentRow].push({
                            v: value,
                            l: length,
                            current: index.split('_')[0] == self.data[self.currentStep].keyname.split('_')[0],
                            barcode: index.match(/_timestamp/gi) || (currentStep[0] && currentStep[0].type == 'barcode') ? true : false
                        })
                    } else {
                        self.previewPrint[currentRow].push({
                            v: values[key],
                            l: length
                        })
                    }
                    currentLength += length
                })
                if (newPreviewStructure) {
                    self.newPreview = true
                    newPreviewStructure.fields.forEach((el) => {
                        let key = el.field

                        if (el.f_id && values[el.f_id]) {
                            const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                            var val = values[el.f_id]
                            log('F_ID: ', el.f_id)
                            log('Val: ', val)
                            var value = val

                            if (values[el.f_id].match(/[\{\}\[\]]/gi)) {
                                let m
                                var index = ''
                                while ((m = regex.exec(val)) !== null) {
                                    // This is necessary to avoid infinite loops with zero-width matches
                                    if (m.index === regex.lastIndex) {
                                        regex.lastIndex++
                                    }

                                    // The result can be accessed through the `m`-variable.
                                    m.forEach((match, groupIndex) => {
                                        index = match.replace(/[\{\}\[\]]/gi, '')
                                        value = value.replace(match, self.oParams[index])
                                        if (el.format && el.type === 'barcode' && !moment(value, el.format, true).isValid()) {
                                            const formats = ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY']
                                            var bConverted = false
                                            formats.forEach((formatValidate) => {
                                                // Crear expresión regular basada en el formato
                                                let formatRegex = formatValidate.replace('DD', '\\d{2}').replace('MM', '\\d{2}').replace('YYYY', '\\d{4}').replace('HH', '\\d{2}').replace('mm', '\\d{2}').replace('ss', '\\d{2}').replace(/\s/g, '\\s')
                                                log('FORMAT REGEX --> ', formatRegex)
                                                const regex = new RegExp(`^.*${formatRegex}.*$`)
                                                log('REGEX --> ', regex)
                                                if (regex.test(value) && !bConverted) {
                                                    log('FORMAT --> ', formatValidate, value)
                                                    var aux = value.replace(moment(value, formatValidate).format(formatValidate), '{date}')
                                                    log('AUX --> ', aux)
                                                    var date = moment(value, formatValidate).format(el.format)
                                                    log('DATE --> ', date)
                                                    value = aux.replace('{date}', date)
                                                    bConverted = true
                                                }
                                            })
                                            // value = moment(moment(value, 'DD/MM/YYYY HH:mm').format(el.format), el.format).isValid() ? moment(value, 'DD/MM/YYYY HH:mm').format(el.format) : value
                                        }

                                        if (['print_date', 'print_date_time', 'print_date_day'].includes(index) && self.bUpdatedPrintDateVisible) {
                                            value += ' *'
                                        }
                                    })
                                }
                                el.current = index.split('_')[0] == self.data[self.currentStep].keyname.split('_')[0]
                            }

                            el.value = el.format && el.type !== 'barcode' ? formatPrintedDateFromStore(value, el.format) : value
                        } else if (el.value && el.value.match(/[\{\}\[\]]/gi)) {
                            const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                            var val = el.value
                            var value = val
                            let m
                            var index = ''
                            while ((m = regex.exec(val)) !== null) {
                                // This is necessary to avoid infinite loops with zero-width matches
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++
                                }

                                // The result can be accessed through the `m`-variable.
                                m.forEach((match, groupIndex) => {
                                    index = match.replace(/[\{\}\[\]]/gi, '')
                                    value = value.replace(match, self.oParams[index])

                                    if (el.format && el.type === 'barcode' && !moment(value, el.format, true).isValid()) {
                                        const dFmt = moment(value, 'DD/MM/YYYY HH:mm', true)
                                        value = dFmt.isValid() ? dFmt.format(el.format) : value
                                    }
                                    if (['print_date', 'print_date_time', 'print_date_day'].includes(index) && self.bUpdatedPrintDateVisible) {
                                        value += ' *'
                                    }
                                })
                            }

                            var currentStep = self.data.filter((step) => {
                                return step.keyname == index
                            })

                            el.current = index.split('_')[0] == self.data[self.currentStep].keyname.split('_')[0]
                            el.value = el.format && el.type !== 'barcode' ? formatPrintedDateFromStore(value, el.format) : value
                        }
                    })
                    self.newPreviewData = Object.assign({}, newPreviewStructure)
                } else {
                    self.newPreview = false
                }
            }
            let date = moment()
            if (!this.bUpdatedPrintDate) {
                try {
                    const options = {
                        timeZone: this.timezone,
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: false
                    }
                    const copy = moment(date)

                    log('1', date.format('DD/MM/YYYY HH:mm'))

                    const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                    const objectDate = {}
                    for (const item of dateTimeFormat) {
                        objectDate[item.type] = item.value
                    }
                    const dateString = `${objectDate['day'].padStart(2, '0')}/${objectDate['month'].padStart(2, '0')}/${objectDate['year']} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`
                    date = moment(dateString, 'DD/MM/YYYY HH:mm')

                    log('2', date.format('DD/MM/YYYY HH:mm'))
                    log('3', date.diff(copy, 'minutes'))
                    log('4', serverTimeDifference)

                    if (date.diff(copy, 'minutes') != serverTimeDifference) {
                        const difference = serverTimeDifference - date.diff(copy, 'minutes')
                        date = date.add(difference, 'minutes')
                    }
                } catch (error) {
                    logError(error)
                }
            }

            this.print_date = this.bUpdatedPrintDate ? this.print_date : date

            if (format) {
                try {
                    const extracted = this.extractZPLFromPrinter(format, printer)
                    const zpl = extracted && extracted.zpl ? extracted.zpl : null
                    const labelName = extracted && extracted.labelName ? extracted.labelName : null
                    if (zpl && this.isValidZPL(zpl)) {
                        let params = this.buildPreviewParams()
                        params = Object.assign({}, params, this.oParams)
                        params['print_date'] = this.print_date.format('DD/MM/YYYY HH:mm')
                        this.openZplPreview({ zpl, format, labelName, params })
                        return
                    }
                } catch (e) {
                    logError('error', e)
                }
            }
        },

        condensedView(value) {
            this.onFocus = value
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },

        changeSelectedState(newState, options) {
            log('changeSelectedState', newState)
            const keepListOpen = Boolean(options && options.keepListOpen)
            if (this.isTemporalTimerCollection) {
                this.syncTemporalCurrentFields()
                // BUILD-7627: clic en desmarcado lo encola detrás; no se pierde el wizard actual
                if (newState && newState.id != null && !isPrintItemSelected(this.selectedLabelsToPrint, newState.id)) {
                    this.selectedLabelsToPrint = insertPrintItemAfterCurrent(
                        this.selectedLabelsToPrint,
                        newState.id,
                        this.label && this.label.id
                    )
                    return
                }
            }
            if (['portrait'].includes(this.$mq) && !keepListOpen) {
                // Colección temporal: Next avanza de producto y debe quedarse
                // en los pasos. El listado portrait se cierra, no se abre.
                this.bShowStates = this.isTemporalTimerCollection ? false : !this.bShowStates
            }
            this.selectedState = newState
            this.processData.selectedState = newState

            for (let key in this.states) {
                let state = this.states[key]
                if (state.id == newState.id && state.stateID.split('_')[0] == newState.stateID && state.collectionID == newState.collectionID && state.referenceID == newState.referenceID) {
                    this.iStateIndex = key
                }
            }

            if (this.printMode === 'printAll') {
                const deepCopyMultiplePrint = JSON.parse(JSON.stringify(this.multiplePrint))
                this.generateProcess()

                //Remplazar el result de data por el estado de deepCopyMultiplePrint
                const selectedState = deepCopyMultiplePrint.find((state) => state.id === newState.id && state.stateID === newState.stateID && state.collectionID === newState.collectionID && state.referenceID === newState.referenceID)
                this.data.forEach((labelOfData) => {
                    if (selectedState) {
                        // Si es quantity, usar directamente la propiedad quantity del selectedState
                        if (labelOfData.keyname === 'quantity') {
                            labelOfData.result = selectedState.quantity
                            return
                        }

                        // Para otros campos, buscar en fields si existe
                        if (selectedState.fields && selectedState.fields.length > 0) {
                            selectedState.fields.forEach((fieldOfSelectedState) => {
                                if (fieldOfSelectedState.keyname === labelOfData.keyname) {
                                    labelOfData.result = fieldOfSelectedState.result
                                }
                            })
                        }
                    }
                })
            } else {
                this.generateProcess()
            }
        },

        /**
         * Misma limpieza que el cancel original: si la colección es temporal,
         * se quita del store. Protege states[0] ausente (producto único).
         */
        removeTemporalCollectionOnCancel() {
            const collections = this.$store.getters['label/getCollections']
            const firstState = this.states && this.states[0]
            if (!collections || !firstState) {
                return
            }
            const currentCollection = collections[firstState.collectionID]
            if (currentCollection && currentCollection.temporal) {
                delete collections[firstState.collectionID]
                this.$store.commit('label/setPredefined', collections)
            }
        },

        cancel(print) {
            // Popup if changes in step done
            var changes = false
            var self = this
            for (var step in this.data) {
                var index = this.data[step]
                if (index.result !== '' && index.keyname != 'state' && index.keyname != 'quantity') {
                    changes = true
                }
            }
            if (self.bUpdatedPrintDate) {
                changes = true
            }

            log('CANCEL', self.bUpdatedPrintDate, print, self.bUpdatedPrintDate, self.digitalState)
            if (changes && !print) {
                self.$popup.confirm({
                    message: self.$t('popup.label_print.message'),
                    textSave: self.$t('popup.label_print.continue'),
                    textCancel: self.$t('register.cancel_complete'),
                    callSave: function () {
                        self.$popup.close()
                    },
                    callCancel: function () {
                        self.removeTemporalCollectionOnCancel()
                        self.$store.commit('label/referenceStateReset', {})
                        self.bShowStates = false
                        self.$emit('unselect')
                        self.$popup.close()
                    }
                })
            } else {
                this.removeTemporalCollectionOnCancel()
                self.$store.commit('label/referenceStateReset', {})
                self.bShowStates = false
                self.$emit('unselect')
            }
            // this.$store.commit('label/referenceStateReset', {})
            // this.bShowStates = false
            // this.$emit('unselect')
        },

        changePrintDate(dates) {
            const date = this.print_date.format('DD/MM/YYYY')
            const time = this.print_date.format('HH:mm')
            const self = this

            if (['portrait'].includes(this.$mq)) {
                const datetime = `${dates.date} ${dates.time}`
                self.print_date = moment(datetime, 'DD/MM/YYYY HH:mm')
                // if print date was modified, show alert, if is first time, validate if new date and time are different from old date and time
                self.bUpdatedPrintDate = self.bUpdatedPrintDate || (!self.bUpdatedPrintDate && (dates.date != dates.oldDate || dates.time != dates.oldTime))
                self.bUpdatedPrintDateVisible = self.bUpdatedPrintDate

                //UPDATE DATE CALENDAR RANGS
                for (var k in self.data) {
                    var step = self.data[k]
                    if (typeof step.minDate !== 'undefined' && typeof step.maxDate !== 'undefined') {
                        var minDate = undefined
                        var maxDate = self.print_date.format('DD/MM/YYYY')

                        if (step.keyname == 'dflevedacao') {
                            var auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                            minDate = auxDate.subtract(4, 'd').format('DD/MM/YYYY')
                            auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                            maxDate = auxDate.subtract(2, 'd').format('DD/MM/YYYY')
                        } else if (step.keyname == 'dftpambiente') {
                            var auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                            minDate = auxDate.subtract(6, 'd').format('DD/MM/YYYY')
                            auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                            maxDate = auxDate.subtract(2, 'd').format('DD/MM/YYYY')
                        }

                        step.minDate = minDate
                        step.maxDate = maxDate
                        self.data[k] = step
                    }
                }

                self.updatePreview()
            } else {
                // show popup
                this.$popup.dateTime({
                    date: date,
                    time: time,
                    only_past: this.bPastLabelling,
                    callSave: function (popupData, store) {
                        if (self.bPastLabelling) {
                            const now = moment()
                            const printDate = moment(`${popupData.date} ${popupData.time}`, 'DD/MM/YYYY HH:mm')
                            if (printDate.isAfter(now)) {
                                // self.$snackbar.error({
                                //     message: i18n.t('tooltip.print_date_out_range'),
                                //     closeable: true
                                // })

                                popupData.showingError = true
                                popupData.messageError = i18n.t('tooltip.print_date_out_range')
                                return
                            }
                        }

                        const datetime = `${popupData.date} ${popupData.time}`
                        self.print_date = moment(datetime, 'DD/MM/YYYY HH:mm')
                        // if print date was modified, show alert, if is first time, validate if new date and time are different from old date and time
                        self.bUpdatedPrintDate = self.bUpdatedPrintDate || (!self.bUpdatedPrintDate && (popupData.date != popupData.oldDate || popupData.time != popupData.oldTime))
                        self.bUpdatedPrintDateVisible = self.bUpdatedPrintDate

                        //UPDATE DATE CALENDAR RANGS
                        for (var k in self.data) {
                            var step = self.data[k]
                            if (typeof step.minDate !== 'undefined' && typeof step.maxDate !== 'undefined') {
                                var minDate = undefined
                                var maxDate = self.print_date.format('DD/MM/YYYY')

                                if (step.keyname == 'dflevedacao') {
                                    var auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                                    minDate = auxDate.subtract(4, 'd').format('DD/MM/YYYY')
                                    auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                                    maxDate = auxDate.subtract(2, 'd').format('DD/MM/YYYY')
                                } else if (step.keyname == 'dftpambiente') {
                                    var auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                                    minDate = auxDate.subtract(6, 'd').format('DD/MM/YYYY')
                                    auxDate = moment(self.print_date.format('YYYY-MM-DD HH:mm:ss'))
                                    maxDate = auxDate.subtract(2, 'd').format('DD/MM/YYYY')
                                }

                                step.minDate = minDate
                                step.maxDate = maxDate
                                self.data[k] = step
                            }
                        }

                        self.changeDatePrintPortrait = false
                        self.updatePreview()
                        self.$popup.close()
                    },
                    callCancel: function () {
                        self.$popup.close()
                        self.changeDatePrintPortrait = false
                    }
                })
            }
        },

        goToConfig() {
            this.$router.push({
                name: 'ConfigPage',
                params: {
                    page: 'printer'
                }
            })
        },
        loadRelatedLabels(state_id) {
            const self = this

            let countSteps = 0
            for (let index in this.data) {
                let step = this.data[index]
                if (typeof step.type !== 'undefined' && ['string', 'date', 'datetime', 'datepast', 'datefree', 'datetimefree', 'datetimepast'].includes(step.type)) {
                    countSteps++
                }
            }

            if (typeof self.relatedLabels[state_id] == 'undefined' && countSteps > 0 && this.$store.getters['getRelatedLabels'] > 0 && typeof this.label.states[state_id].related_state_status !== 'undefined' && this.label.states[state_id].related_state_status) {
                this.$store
                    .dispatch('label/getRelatedLabels', {
                        state_id: state_id,
                        reference_id: self.processData.label.id,
                        format_id: self.label.states[state_id].format
                    })
                    .then((response) => {
                        self.relatedLabels[state_id] = response
                        self.relatedLabels = { ...self.relatedLabels }
                        this.isLoadedRelatedLabels = true

                        if (response.status === false) {
                            this.isErrorRelatedLabels = true
                        } else {
                            this.isErrorRelatedLabels = false
                        }
                    })
                    .catch((error) => {
                        this.isLoadedRelatedLabels = true
                        this.isErrorRelatedLabels = true
                    })
            }
        },
        selectRelatedValue(pType, i, value) {
            // declare variables to reuse in multiple cases
            let date
            switch (pType) {
                case 'string':
                    if (typeof this.$refs[`step-${i}`] !== 'undefined' && typeof this.$refs[`step-${i}`][0] !== 'undefined') {
                        // update selected related value in dom element
                        const stepRef = this.$refs[`step-${i}`][0]
                        stepRef.value = value
                    }
                    break
                case 'date':
                case 'datefree':
                case 'datepast':
                    date = moment(value, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')
                    this.data[i].result = date
                    date = moment(date, 'DD/MM/YYYY').format('YYYY/MM/DD')
                    value = date
                    this.calendarKey++
                    break
                case 'datetime':
                case 'datetimefree':
                case 'datetimepast':
                    this.data[i].result = value
                    this.calendarKey++
                    break
            }
            this.setProcessResult(pType, i, value)
        },
        formatTimeToMax(timeToFormat) {
            if (typeof timeToFormat === 'undefined') return { result: null, format: 'minute' }
            var year = 365 * 24 * 60
            var month = 30 * 60 * 24
            var day = 60 * 24
            var hours = 60
            var result = false
            var format = false

            // if (timeToFormat % year == 0) {
            //     result = Math.floor(timeToFormat / year)
            //     format = 'year'
            // } else if (timeToFormat < year && timeToFormat % month == 0) {
            //     result = Math.floor(timeToFormat / month)
            //     format = 'month'
            // } else if (timeToFormat > year) {
            //     // Se calculan los años enteros y se obtienen los meses restantes, si los meses son enteros, los devuelve
            //     var years = Math.floor(timeToFormat / year)
            //     var months = timeToFormat - years * year
            //     if (months % month == 0) {
            //         result = Math.floor(months / month) + years * 12
            //         format = 'month'
            //     }
            // } else if (timeToFormat % day == 0) {
            //     result = Math.floor(timeToFormat / day)
            //     format = 'day'
            // } else if (timeToFormat % hours == 0) {
            //     result = Math.floor(timeToFormat / hours)
            //     format = 'hour'
            // } else {
            //     result = timeToFormat
            //     format = 'minute'
            // }
            result = timeToFormat
            format = 'minute'
            return { result: result, format: format }
        },
        reloadRelatedLabels() {
            const self = this
            this.$store
                .dispatch('label/getRelatedLabels', {
                    state_id: self.processData.selectedState.id,
                    reference_id: self.processData.label.id,
                    format_id: self.processData.label.states[self.processData.selectedState.id].format
                })
                .then((response) => {
                    self.relatedLabels[self.processData.selectedState.id] = response
                    self.relatedLabels = { ...self.relatedLabels }

                    this.isLoadedRelatedLabels = true

                    if (response.status === false) {
                        this.isErrorRelatedLabels = true
                    } else {
                        this.isErrorRelatedLabels = false
                    }
                })
                .catch((error) => {
                    this.isLoadedRelatedLabels = true
                    this.isErrorRelatedLabels = true
                })
        },

        // Métodos para manejar imprimir todo vs seleccionadas
        togglePrintMode() {
            this.showPrintAllMode = !this.showPrintAllMode
        },

        getSelectedLabels() {
            if (this.isCollectionRules() && this.printMode === 'printAll') {
                return this.multiplePrint.filter((label) => label.toPrintSelected)
            }
            return this.states
        },
        showSnackbarDataMissing() {
            this.$snackbar.error({
                message: this.$t('tooltip.print_data_missing_multiple_print'),
                closeable: true,
                timeout: 3000
            })
        },

        cantUpdateKey(pType) {
            return pType != 'quantity'
        },

        stepByIndex(index) {
            return getProcessStep(this.data, index)
        },

        stepKeySuffix(pType, index) {
            if (this.cantUpdateKey(pType)) {
                return ''
            }
            const step = this.stepByIndex(index)
            return step && step.result != null ? step.result : ''
        },

        /**
         * Plantilla ausente o sin `data`: no se dejan pasos a medias.
         * `newPreview` en false muestra el aviso de configuración inválida.
         */
        markMissingPrintFormat() {
            this.newPreview = false
            this.previewPrint = []
            this.current_template_error = true
        }
    },
    created() {
        this.productName = this.label.name
        this.processData = {
            label: this.label,
            selectedState: {}
        }

        this.timezone = this.$store.getters['getTimeZoneName']

        this.generateProcess()

        if (this.processData.selectedState) {
            this.loadRelatedLabels(this.processData.selectedState.id)
        }

        if (this.isTemporalTimerCollection) {
            this.bShowStates = !['portrait'].includes(this.$mq)
        } else if (this.multiplePrint) {
            const canPrint = this.canPrintMutlipleLabels
            if (!canPrint) {
                this.bShowStates = true
                setTimeout(() => {
                    this.showSnackbarDataMissing()
                }, 300)
            }
        }
    },
    mounted() {},
    beforeUnmount() {
        this.teardownFullPreviewResizeObserver()
    },
    watch: {
        $mq: function (newVal, oldVal) {
            if (newVal == 'portrait') {
                if (this.fullPreview) {
                    this.fullPreview = false
                    this.showPreviewPortrait = true
                }
            }
        },

        currentPrinter(newVal, oldVal) {
            this.validatePrinterConfiguration(true, true)
        },
        selectedCollection() {
            this.temporalSelectionInitialized = false
        },
        data: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal && this.printMode === 'printAll') {
                    if (this.multiplePrint) {
                        const selectedLabel = Object.entries(this.multiplePrint).reduce((acc, [key, label]) => {
                            if (samePrintItemId(label.id, this.selectedState.id)) {
                                if (label.fields) {
                                    // Buscar quantity en el objeto newVal
                                    Object.values(newVal).forEach((value) => {
                                        if (value.keyname === 'quantity') {
                                            const valueInt = parseInt(value.result)
                                            if (valueInt > 0) {
                                                label.quantity = valueInt
                                            }
                                        }
                                    })
                                    label.fields = newVal
                                }
                                return label
                            }
                            return acc
                        }, {})
                        this.multiplePrint[this.selectedCollection] = selectedLabel
                    }
                }
            }
        }
    },
    updated() {}
}
</script>

<style lang="scss">
#content.label-print {
    > .content {
        padding: 6px !important;
        overflow: hidden !important;

        .full-preview {
            @include display-flex();
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: 2rem;

            .full-preview-content {
                width: unquote('min(90vw, 640px)');
                max-width: unquote('min(90vw, 640px)');
                max-height: 75vh;
                flex: 0 0 auto;
                min-height: 0;
                overflow: visible;
                background: #fff;
                border-radius: rem(8px);
                box-shadow: 0 rem(4px) rem(20px) rgba(0, 0, 0, 0.15);
                padding: 0;
                flex-shrink: 0;
                @include display-flex();
                flex-direction: column;
                justify-content: center;
                align-items: center;

                > * {
                    width: 100%;
                    max-width: 100%;
                    flex: 0 0 auto;
                }

                &.full-preview-content--normal {
                    overflow: hidden;

                    .preview-normal-fit {
                        width: 100%;
                        height: 100%;
                        @include display-flex();
                        justify-content: center;
                        align-items: center;
                        min-height: 0;
                    }

                    .preview-normal-fit-scaled {
                        overflow: hidden;
                        flex-shrink: 0;
                    }

                    .preview-normal-fit-inner {
                        overflow: hidden;
                    }
                }
            }

            .btn-close {
                @include border-radius(4px);
                @include interaction;
                background-color: #fff;
                opacity: 0.7;
                margin-top: rem(20px);
                padding: rem(10px) rem(20px);
                color: #444;
                font-family: $text-sbold;
                flex-shrink: 0;

                @include bgHover(darken(#fff, 5%));
            }

            .close-preview {
                position: absolute;
                @include background($image: img('close_preview_dark.svg'), $position: center center, $size: 20px, $color: #fff);
                @include border-radius(4px);
                @include interaction();
                width: 40px;
                height: 40px;
                top: 20px;
                right: 20px;
            }
        }

        #center-block {
            $pinfo-height: rem(35px);
            $wizard-height: rem(80px);

            @include border-radius($default-border-radius);
            width: 75%;
            // max-width: calc(100% - #{rem(300px)});
            height: 100%;
            background: #fff;
            display: inline-block;
            // overflow: auto;
            padding: 12px 0;

            // Solo el aviso "sin cantidad" necesita llenar el área para centrarse; no afectar time/number/barcode/aqr.
            .input-number:has(.no-quantity-message-container) {
                height: 100%;
                width: 100%;

                .no-quantity-message-container {
                    height: 100%;
                    width: 100%;
                    display: grid;
                    place-items: center;

                    .no-quantity-message {
                        display: flex;
                        padding: 16px;
                        background-color: $info-light;
                        border-radius: 4px;
                        gap: 8px;
                        align-items: center;

                        .i-andy-info-main {
                            color: $info-dark;
                            width: fit-content;
                            height: fit-content;
                        }

                        .text {
                            font-size: 16px;
                            font-family: $text;
                        }
                    }
                }
            }

            .product-info {
                width: 100%;
                text-align: center;
                height: $pinfo-height;

                .product-title {
                    @include background($size: $pinfo-height, $position: left center);
                    @include font-size(l);
                    @include text-ellipsis();
                    width: fit-content;
                    font-family: $text-bold;
                    color: $main;
                    line-height: $pinfo-height;
                    margin: 0 auto;
                    max-width: 100%;

                    &.image {
                        padding-left: rem(60px);
                    }
                }
            }

            .wizard {
                width: 100%;
                height: $wizard-height;
                padding: 0 $alex-app-padding;
                text-align: center;

                .resume {
                    @include display-flex();
                    @include align-items();
                    @include justify-content();
                    @include flex-direction(row);
                    @include flex-wrap(wrap);
                    width: calc(100% - #{rem(20px)});
                    height: rem(20px);
                    margin: 0 12px 12px 12px;

                    .resume-step {
                        border-top: 4px solid $neutro;
                        display: inline-block;
                        position: relative;

                        &:first-of-type {
                            border-color: transparent !important;
                            width: 0px !important;
                        }

                        &:last-of-type {
                        }

                        &:after {
                            @include border-radius(50%);
                            @include background($color: $neutro);
                            content: '';
                            width: rem(12px);
                            height: rem(12px);
                            position: absolute;
                            top: rem(-1 * 8px);
                            right: rem(-1 * 6px);
                            transition-duration: 0.1s;
                            z-index: $z-column;
                        }

                        &.done {
                            border-color: $main;

                            &:after {
                                background-color: $main;
                            }
                        }
                    }
                }

                .nav {
                    width: calc(100% - #{rem(20px)});
                    height: rem(35px);
                    margin: 0 10px;
                    line-height: rem(35px);

                    .action {
                        @include interaction();
                        width: 25%;
                        display: inline-block;
                        height: rem(35px);

                        .text {
                            @include text-ellipsis();
                            @include font-size(m);
                            display: inline-block;
                            width: calc(100% - #{rem(45px)});
                            color: $main;
                        }

                        &.right .text {
                            text-align: right;
                        }

                        button {
                            $margin: rem(10px);

                            display: inline-block;
                            width: rem(35px);
                            height: rem(35px);
                            border-radius: $default-border-radius;

                            &.back {
                                @include background($image: img('left_arrow_primary.svg'), $size: 25px, $position: center center, $color: $neutro);
                                margin-right: $margin;
                                @include bgHover($neutro);
                            }

                            &.next {
                                @include background($image: img('right_arrow_light.svg'), $size: 25px, $position: center center, $color: $main);
                                margin-left: $margin;
                                @include bgHover($main);
                            }
                        }

                        &.disabled {
                            .text {
                                color: $neutro;
                            }

                            button {
                                &.next {
                                    background-color: $inactive;
                                }
                            }
                        }
                    }

                    .current-action {
                        @include font-size(l);
                        line-height: 100%;
                        font-family: $text-bold;
                        text-align: center;
                        color: $main;
                        width: 50%;
                        min-height: rem(35px);
                        height: auto;
                        display: inline-block;
                        padding: 0 6px;
                    }
                }
            }

            .content {
                width: 100%;
                height: calc(100% - #{$pinfo-height + $wizard-height});
                min-height: 100px;
                padding: 24px 0;
                overflow-y: auto;

                .step {
                    @include height-fit-content();
                    width: 100%;
                    display: none;
                }

                .step.current {
                    display: block;

                    &:has(.no-quantity-message-container) {
                        height: 100%;
                    }

                    .can-not-print {
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(center);
                        width: 100%;

                        .text {
                            padding: 4px;
                            @include font-size(14px);
                            color: $error-dark;
                        }
                    }
                }

                .step-message {
                    @include font-size(sm);
                    color: #666;
                    text-align: center;
                    margin-top: 0;
                }

                .input {
                    &.related {
                        flex-wrap: wrap;

                        .related-labels {
                            @include display-flex();
                            @include align-items(flex-start);
                            width: 100%;
                            padding: calc(0.375rem + 10px);
                        }
                    }
                }
            }

            .tags {
                height: rem(90px);
                width: 100%;
                padding-left: 24px;
                overflow-x: auto;
                margin-top: $alex-app-padding * 2;

                .carrousel {
                    @include display-inline-flex();
                    overflow-x: overlay;

                    .tag {
                        @include interaction();
                        @include border-radius($default-border-radius);
                        @include display-inline-flex();
                        @include align-items();
                        @include justify-content();
                        @include font-size(m);
                        color: $main;
                        font-family: $text-bold;
                        text-align: center;
                        text-transform: uppercase;
                        height: rem(90px);
                        width: auto;
                        max-width: 225px;
                        margin: 0 $alex-app-padding;
                        padding: 0 $alex-app-padding * 2;
                        background-color: $default-bg-color;

                        @include bgHover($default-bg-color);

                        &.selected {
                            background-color: $main;
                            color: #fff;
                            @include bgHover($main);
                        }
                    }
                }
            }
        }

        .column {
            $header: rem(70px);
            $footer: rem(185px);

            // min-width: rem(300px);
            width: calc(25% - #{$alex-app-padding});
            height: 100%;
            padding-left: 0;
            padding-right: 0;
            display: inline-block;
            position: relative;
            float: right;

            .collections_header {
                @include display-flex();
                @include align-items();
                height: $header;
                padding-bottom: 20px;

                .counter {
                    @include border-radius(4px);
                    @include display-inline-flex();
                    @include align-items();
                    flex-wrap: wrap;
                    height: rem(50px);
                    width: 80px;
                    background-color: #ffffff;

                    &.can-not-print {
                        background-color: $error-t90;
                        border-style: solid;
                        border-width: 1px;
                        border-color: $error-dark;

                        .value {
                            color: $error-dark;
                        }
                    }

                    .value {
                        @include font-size(l);
                        font-family: $conden-bold;
                        text-align: center;
                        color: $main;
                        width: 100%;
                    }

                    .description {
                        @include font-size(sm);
                        font-family: $conden;
                        text-align: center;
                        color: $neutro-s50;
                        width: 100%;
                    }
                }

                .change_view {
                    @include font-size(sm);
                    width: 100%;
                    height: 100%;
                    padding-right: 6px;
                    text-align: right;

                    span {
                        @include background($image: img('right_arrow_dark.svg'), $size: 20px, $position: center right);
                        font-family: $text-medium;
                        color: $neutro-s70;
                        padding-right: 30px;
                        line-height: 50px;
                        text-align: right;
                        display: inline-block;
                        width: fit-content;
                        cursor: pointer;
                    }
                }
            }

            .titl {
                @include font-size(sm);
                font-family: $text-medium;
                color: $neutro-s90;
                text-align: left;
                width: 100%;
                margin-bottom: 6px;
            }

            select {
                @include border-radius(4px);
                @include font-size(sm);
                @include background($image: img('down_caret_neutro_s90.svg'), $position: center right 15px, $size: 10px);
                @include text-ellipsis();
                -webkit-appearance: none;
                -moz-appearance: none;
                font-family: $text-bold;
                color: $neutro-s90;
                background-color: #fff;
                border: none;
                padding-right: 30px;
                width: 100%;
                height: 40px;
            }

            .preview-info {
                @include display-flex();
                @include flex-direction(column);
                height: calc(100% - #{$footer});
                overflow: auto;
                padding: 0;

                &.print-all-mode {
                    padding: 0;
                    width: 100% !important;
                    height: calc(100% - 330px) !important;

                    &.portrit-selector {
                        height: calc(100% - 10px - 80px);
                        width: unset;
                        padding: 0 15px;
                        padding-top: 10px;
                    }
                }

                .preview-title {
                    @include display-flex();
                    @include align-items(center);
                    width: 100%;
                    height: 40px;
                    padding-bottom: 6px;
                    margin-bottom: 6px;
                    padding-top: 10px;

                    .titl {
                        @include font-size(s);
                        font-family: $text-medium;
                        color: $neutro-s90;
                        text-align: left;
                        width: 100%;
                        margin-bottom: 6px;
                    }
                    .maximize-preview {
                        @include background($image: img('eye_preview_dark.svg'), $position: center center, $size: 20px, $color: #fff);
                        @include border-radius(4px);
                        @include interaction();
                        width: 40px;
                        height: 40px;
                    }
                }

                .zpl-preview-wrapper {
                    flex: 0 0 auto;
                    min-height: 0;
                    overflow: hidden;
                    @include display-flex();
                    flex-direction: column;
                    width: 100%;
                }

                select {
                    @include border-radius(4px);
                    @include font-size(sm);
                    @include background($image: img('down_caret_neutro_s90.svg'), $position: center right 15px, $size: 10px);
                    @include text-ellipsis();
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    font-family: $text-bold;
                    color: $neutro-s90;
                    background-color: #fff;
                    border: none;
                    padding-right: 30px;
                    width: 100%;
                    height: 40px;
                }

                .preview {
                    @include box-shadow($h: 0px, $v: 0px, $b: 10px, $s: 0px, $c: rgba(131, 131, 133, 0.25));
                    width: 100%;
                    min-height: 25%;
                    max-height: calc(100% - 24px - 23px - 10px);
                    height: auto;
                    overflow: auto;
                    background-color: #fff;
                    border: rem(2px) $check-answer !important;
                    border-radius: $default-border-radius;
                    margin-bottom: 6px;

                    span u {
                        text-decoration: underline;
                        font-family: $conden;
                    }

                    .row {
                        width: 100%;
                        min-height: rem(26px);
                        height: auto;
                        line-height: 100%;
                        padding: 0 3px;

                        &:nth-child(even) {
                            background: $neutro-t50;
                        }

                        .col {
                            display: inline-block;
                            margin: 0;
                            transition-duration: 0.1s;
                            line-height: rem(24px);

                            &.c1 {
                                width: 25%;
                            }

                            &.c2 {
                                width: 50%;
                            }

                            &.c3 {
                                width: 75%;
                            }

                            &.c4 {
                                width: 100%;
                            }

                            span {
                                @include font-size(sm);
                                @include text-ellipsis();
                                font-family: $conden;
                                display: block;

                                b,
                                em,
                                strong,
                                u,
                                i {
                                    font-size: inherit;
                                    font-family: inherit;
                                    white-space: inherit;
                                }
                            }

                            .vue-barcode-element {
                                height: 50px;
                            }

                            &.current {
                                @include border-radius(3px);
                                background-color: $progress;
                                padding: 2px 3px;
                                margin: 3px 0 0 0;

                                span {
                                    color: #fff;
                                    font-family: $conden-bold;
                                }
                            }
                        }
                    }
                }

                .print_date {
                    min-height: 40px;

                    .section {
                        @include display-flex();
                        @include align-items(flex-end);
                        @include justify-content(flex-end);
                        width: auto;

                        .label {
                            @include font-size(m);
                            font-family: $conden-light;
                            color: $neutro-s70;
                            margin-right: 3px;
                        }

                        .value {
                            @include font-size(m);
                            font-family: $conden;
                            color: $neutro-s70;
                            text-decoration: underline;
                            cursor: pointer;
                        }

                        .modify_date {
                            @include background($image: img('alert_complem.svg'), $position: left center, $size: 15px);
                            padding-left: 20px;
                            @include font-size(m);
                            font-family: $conden;
                            color: $warning-s30;
                        }

                        &:nth-child(1) {
                            padding-top: 8px;
                        }
                    }
                }

                .quantity {
                    text-align: right;
                    width: 100%;
                    height: 32px;
                    padding-top: 8px;

                    span {
                        @include font-size(ml);
                        font-family: $text;
                        color: $neutro-s90;

                        .units {
                            font-family: $text-bold;
                        }
                    }
                }

                .states_labels {
                    width: 100%;
                    min-height: 25%;

                    .state-label-container {
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(flex-start);
                        @include flex-direction(row);
                        position: relative;

                        .input-selector {
                            width: 26%;
                            height: 95%;
                            position: absolute;
                            z-index: 6;
                            cursor: pointer;
                        }

                        input[type='checkbox'] {
                            appearance: none;
                            position: absolute;
                            z-index: 5;
                            left: 10px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 16px;
                            height: 16px;
                            border-radius: 4px;
                            padding: 8px;
                            border: 1px solid $color-black;
                            background-color: #fff;
                            background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
                            cursor: pointer;

                            &:checked {
                                background-color: $main;
                                border: 1px solid $main;
                                color: #fff;

                                &:before {
                                    content: '';
                                    width: 16px;
                                    height: 16px;
                                }
                            }

                            /* &.can-not-print {
                                border: 1px solid $error-dark;

                                &:checked {
                                    background-color: $error;
                                    border: 1px solid $error-dark;
                                }
                            } */
                        }
                    }
                }

                &.collection {
                    height: calc(100% - 230px);
                }

                &.collection-desktop {
                    height: calc(100% - 317px);
                }

                &.desktop-labelling {
                    height: calc(100%);
                    padding: 0;
                }

                &.desktop-labelling-collection {
                    height: calc(100% - 310px);
                }

                &.landscape-labelling {
                    height: calc(100% - 170px);
                }

                &.landscape-labelling-collection {
                    height: calc(100% - 225px);
                }
            }

            .preview-error {
                .error-message {
                    @include font-size(m);
                    font-family: $text-medium;
                }

                .btn {
                    @include default-box-shadow($o: 0.1);
                    margin-top: 12px;
                    background-color: #fff;
                    color: $neutro-s90;
                }
            }

            .footer {
                min-height: rem(40px);
                max-height: $footer;
                width: calc(100%);
                position: absolute;
                bottom: 0;

                .can-not-print {
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    width: 100%;

                    .text {
                        @include font-size(14px);
                        color: $error-dark;
                    }
                }

                .print-mode-selector {
                    @include display-flex();
                    @include align-items(center);
                    width: 100%;
                    height: 100%;

                    .act {
                        &.save {
                            height: rem(80px);
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(center);
                            gap: 8px;
                            @include font-size(24px);
                            border-radius: 4px 0px 0px 4px;

                            .i-andy-printer {
                                color: $color-white;
                            }
                        }
                    }

                    .i-andy-menu-config {
                        color: $color-white;
                        cursor: pointer;
                        background-color: $main;
                        width: rem(100px);
                        border-radius: 0px 4px 4px 0px;
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(center);
                        height: rem(80px);
                        margin-top: 6px;
                        border-left: 1px solid $color-white;
                    }
                }

                button {
                    @include interaction();
                    @include font-size(sm);
                    @include border-radius(6px);
                    border: 1px solid rgba(131, 131, 131, 0.03);
                    width: calc(100%);
                    padding: 10px 20px;
                    color: $main;
                    font-family: $text-light;
                    background-color: #fff;
                    float: right;

                    @include bgHover(#fff);

                    &.save {
                        @include font-size(xl);
                        color: #fff;
                        background-color: $main;
                        font-family: $text-bold;
                        border: none;
                        margin-top: 6px;
                        height: rem(100px);

                        @include bgHover($main);
                    }

                    &.print {
                        @include display-flex();
                        @include justify-content();
                        @include align-items(center);
                        flex-wrap: wrap;

                        &:before {
                            content: '';
                            @include background($image: img('printer_ffffff.svg'), $size: 35px);
                            margin-right: 15px;
                            width: 40px;
                            height: 40px;
                            display: inline-block;
                        }

                        &.digital {
                            &:before {
                                content: '';
                                @include background($image: img('save_ffffff.svg'), $size: 35px);
                                margin-right: 10px;
                                width: 40px;
                                height: 40px;
                                display: inline-block;
                            }
                        }
                    }

                    &.disabled {
                        opacity: 0.3;
                    }

                    &.cancel {
                        @include border-radius(6px);
                        @include font-size(l);
                        color: $neutro-s50;
                        float: left;
                        height: rem(60px);
                        margin-top: 6px;
                    }
                }
            }
        }

        &.landscape-tablet {
            $m-pinfo-height: rem(30px);
            $m-wizard-height: rem(75px);

            #center-block {
                width: 75%;
                max-width: calc(100% - #{rem(240px)});
                padding: 6px 0;

                .product-info {
                    height: $m-pinfo-height;

                    .product-title {
                        @include font-size(ml);
                        line-height: $m-pinfo-height;
                    }
                }

                .wizard {
                    height: $m-wizard-height;

                    .resume-step {
                        &:after {
                            width: rem(10px);
                            height: rem(10px);
                            top: rem(-1 * 7px);
                            right: rem(-1 * 5px);
                        }
                    }

                    .nav {
                        .action {
                            .text {
                                @include font-size(sm);
                                opacity: 0;
                            }
                        }

                        .current-action {
                            @include font-size(m);
                        }
                    }
                }

                .content {
                    height: calc(100% - #{$m-pinfo-height + $m-wizard-height});
                    padding-top: 6px;
                }

                .tags {
                    .carrousel {
                        .tag {
                            @include font-size(sm);
                        }
                    }
                }
            }

            .column {
                min-width: rem(240px);
                width: calc(25% - #{$alex-app-padding});
                padding: 0px;
                padding-left: 0px;

                .preview {
                    max-height: 45%;

                    .row {
                        .col {
                            @include font-size(s);
                        }
                    }
                }

                .change_view {
                    span {
                        line-height: 25px !important;
                    }
                }

                .quantity {
                    @include font-size(m);
                }

                .footer {
                    button {
                        &.save {
                            @include font-size(l);
                            height: rem(60px);
                        }

                        &.print {
                            @include display-flex();
                            @include justify-content();
                            @include align-items(center);
                            flex-wrap: wrap;

                            &:before {
                                background-size: 25px;
                                margin-right: 8px;
                                width: 30px;
                                height: 30px;
                            }
                        }

                        &.cancel {
                            @include font-size(m);
                            height: rem(40px);
                        }
                    }
                }
            }

            &.condensed {
                #center-block {
                    .product-info {
                        display: none;
                    }
                }

                .column {
                    .titl,
                    .preview {
                        display: none;
                    }

                    .preview-title {
                        display: none;
                    }

                    // #preview-container {
                    //     display: none;
                    // }
                    .footer {
                        button.cancel {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>

<!-- // PORTRAIT STYLES -->
<style lang="scss">
#content.label-print {
    .content {
        &.portrait {
            #center-block {
                @include display-flex();
                @include flex-direction(column);

                padding: 0px;
                width: 100%;
                min-width: 100%;
                max-width: 100%;
                background-color: transparent;

                .product-info {
                    @include display-flex();
                    @include justify-content(space-between);
                    @include align-items(center);
                    width: 100%;
                    height: auto;

                    .product-title {
                        @include font-size(20px);
                        @include text-ellipsis();
                        background-size: contain;
                        width: fit-content;
                        font-family: $text-medium;
                        color: $neutro-s80;
                        margin: 0px;
                    }

                    .collection-btn {
                        @include border-radius(4px);
                        @include background($image: img('collection_list_portrait.svg'), $size: 28px);
                        background-color: #fff;
                        width: 45px;
                        height: 45px;
                        cursor: pointer;
                        margin-left: auto;
                        min-width: 45px;
                        margin-right: 7px;

                        &.selected {
                            @include background($image: img('collection_list_portrait_active.svg'), $size: 28px);
                            background-color: $main-dark;
                        }
                    }

                    .preview-btn {
                        @include border-radius(4px);
                        @include background($image: img('eye_preview_dark.svg'), $size: 28px);
                        background-color: #fff;
                        width: 45px;
                        height: 45px;
                        min-width: 45px;
                        cursor: pointer;

                        &.selected {
                            @include background($image: img('eye_preview_light.svg'), $size: 28px);
                            background-color: $main-dark;
                        }

                        &.disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                        }
                    }

                    .counter {
                        @include display-flex();
                        @include border-radius(4px);
                        background-color: #fff;
                        padding: 10px 20px 10px 10px;

                        &.can-not-print {
                            background-color: $error-t90;
                            border-style: solid;
                            border-width: 1px;
                            border-color: $error-dark;

                            .value {
                                color: $error-dark;
                            }
                        }

                        .value {
                            @include font-size(xl);
                            color: $main-dark;
                            font-family: $conden-bold;
                            padding-right: 6px;
                        }

                        .description {
                            @include font-size(18px);
                            font-family: $conden;
                            color: $neutro-s50;
                            text-transform: uppercase;
                        }
                    }

                    &.collection {
                        padding-bottom: 25px;
                    }
                }

                .preview-info {
                    height: 100%;
                    max-height: calc(100% - 80px);
                    padding: 0px 15px;

                    &.print-all-mode {
                        padding: 0;
                    }

                    .states_labels {
                        height: inherit;
                        overflow-y: scroll;

                        .state-label-container {
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(flex-start);
                            @include flex-direction(row);
                            position: relative;

                            .input-selector {
                                width: 20%;
                                height: 95%;
                                position: absolute;
                                z-index: 6;
                                cursor: pointer;
                            }

                            input[type='checkbox'] {
                                appearance: none;
                                position: absolute;
                                z-index: 5;
                                left: 10px;
                                top: 50%;
                                transform: translateY(-50%);
                                width: 16px;
                                height: 16px;
                                border-radius: 4px;
                                padding: 8px;
                                border: 1px solid $color-black;
                                background-color: #fff;
                                background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
                                cursor: pointer;

                                &:checked {
                                    background-color: $main;
                                    border: 1px solid $main;
                                    color: #fff;

                                    &:before {
                                        content: '';
                                        width: 16px;
                                        height: 16px;
                                    }
                                }

                                /* &.can-not-print {
                                    border: 1px solid $error-dark;

                                    &:checked {
                                        background-color: $error;
                                        border: 1px solid $error-dark;
                                    }
                                } */
                            }
                        }
                    }
                }

                .wizard {
                    width: 100%;
                    height: 35px;
                    padding: 0px;
                    margin-top: 20px;

                    .nav {
                        @include display-flex();
                        @include justify-content(space-between);
                        @include align-items(center);
                        height: 100%;
                        width: 100%;
                        margin: 0px;

                        .current-action {
                            @include display-flex();
                            @include justify-content();
                            @include align-items();
                            @include font-size(17px);
                            // @include text-ellipsis();
                            width: fit-content;
                            padding: 0px;
                            margin: 0px;
                            font-family: $text-sbold;
                            height: fit-content;
                            line-height: 17px;
                        }

                        .action {
                            height: 35px;
                            width: 35px;

                            .next,
                            .back {
                                width: 35px;
                                height: 35px;
                                margin-left: 0px;
                                margin-right: 0px;
                            }

                            &.none {
                                opacity: 0;
                            }
                        }

                        .empty {
                            display: none;
                        }
                    }
                }

                // PASOS DEL WIZARD
                .content {
                    width: 100%;
                    height: 100%;
                    overflow-y: auto !important;

                    .step {
                        width: 100%;
                        height: 100%;

                        .can-not-print {
                            display: none;
                        }

                        .fcalendar-container.input {
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            max-width: 100%;
                            box-sizing: border-box;
                        }

                        .tags {
                            padding: 0px;
                            margin: 0px;
                            width: 100%;
                            height: 100%;

                            .carrousel {
                                @include display-flex();
                                @include flex-direction(column);
                                @include align-items(center);
                                gap: 6px;
                                height: auto;
                                width: 100%;
                                margin: 0 auto;
                                max-width: 300px;

                                .tag {
                                    @include border-radius(3px);
                                    background-color: #fff;
                                    width: 100%;
                                    margin: 0px;
                                    height: 6rem;
                                    padding: 5px;

                                    &.selected {
                                        background-color: $main-dark;
                                    }
                                }
                            }
                        }

                        .input-text {
                            @include display-flex();
                            height: 100%;
                            width: 100%;

                            .input-ticketing {
                                @include background($image: img('input_text_portrait.svg'), $position: 15px center, $size: 30px);
                                align-self: center;
                                padding-right: 10px;
                                background-color: #fff;
                            }
                        }

                        .input {
                            &.related {
                                .input-container,
                                .calendar-container {
                                    height: unset;
                                }

                                .calendar-container {
                                    margin-bottom: 30px;
                                }

                                .related-labels {
                                    padding: 0;

                                    .related-values {
                                        .container {
                                            .item {
                                                @include font-size(s);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .input-number {
                            height: 100%;

                            .pin {
                                background-color: transparent;
                                width: 5rem !important;
                            }
                        }

                        // Calendario adaptado a portrait
                        .p-date {
                            width: 100%;
                            height: 100%;

                            .calendar-container {
                                width: 100%;
                                height: 100%;
                                margin-top: 0px;

                                .vfc-styles-conditional-class {
                                    @include display-flex();
                                    @include align-items(center);
                                    width: 100%;
                                    height: 100%;
                                    flex-direction: column;

                                    .vfc-main-container {
                                        @include border-radius(8px);
                                        width: 100%;
                                        height: auto !important;
                                        padding: 18px 10px;

                                        .vfc-calendars {
                                            width: 100%;
                                            height: 100%;
                                            background-color: #fff;

                                            .vfc-content {
                                                background-color: #fff;
                                                width: 100%;
                                                height: auto;
                                                margin: 0 !important;

                                                .vfc-marked {
                                                    background-color: $main-dark !important;
                                                }

                                                .vfc-top-date {
                                                    position: relative;
                                                    top: -8px;
                                                }
                                            }
                                        }

                                        .vfc-navigation-buttons {
                                            height: 40px;

                                            .vfc-cursor-pointer {
                                                width: 40px;
                                                height: 40px;
                                                background-color: #eeeeee;

                                                .vfc-arrow-right {
                                                    top: -5px;
                                                    right: 0px;
                                                }

                                                .vfc-arrow-left {
                                                    top: -5px;
                                                    left: 5px;
                                                }

                                                .vfc-disabled {
                                                    top: 0px !important;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // Fin estilos calendario
                    }
                }

                .footer {
                    gap: 4px;
                    padding-bottom: 0px;

                    .can-not-print {
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(center);
                        width: 100%;

                        .text {
                            @include font-size(14px);
                            color: $error-dark;
                        }
                    }

                    .actions-container {
                        width: 100%;
                        @include display-flex();
                        @include justify-content(space-between);
                        @include align-items(center);
                        flex-direction: row;
                        width: 100%;
                        height: 50px;
                        z-index: 10;
                        gap: 4px;

                        .act {
                            width: 100%;
                            padding: 16px;
                            @include font-size(s);

                            &.save {
                                height: 95%;
                            }
                        }
                    }

                    @include display-flex();
                    @include justify-content(space-between);
                    @include align-items(center);
                    flex-direction: column;

                    .act {
                        @include border-radius(4px);
                        padding: 16px;
                        font-family: $text-bold;
                        width: 100%;

                        &.cancel {
                            background-color: #e3e7ed;
                            color: $main;
                            font-family: $text;
                        }

                        &.save {
                            background-color: $main;
                            color: #fff;
                            width: 100%;

                            &.disabled {
                                background-color: #bfbfcc;
                                cursor: not-allowed;
                            }
                        }
                    }

                    .print-mode-selector {
                        @include display-flex();
                        @include align-items(center);
                        width: 100%;
                        height: 100%;

                        .act {
                            &.save {
                                border-radius: 4px 0px 0px 4px;
                            }
                        }

                        .i-andy-menu-config {
                            color: $color-white;
                            cursor: pointer;
                            background-color: $main;
                            height: 95%;
                            padding: 0 8px;
                            border-radius: 0px 4px 4px 0px;
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(center);
                        }
                    }
                }
            }

            .column.right {
                position: absolute;
                top: 60px;
                left: 6px;
                width: calc(100% - 12px);
                background-color: $default-bg-color;
                height: calc(100% - 0px);
                overflow: hidden;
                z-index: 40;
                padding: 0;

                .preview-error {
                    padding: 0 15px !important;
                }

                .titl {
                    padding: 0 15px !important;

                    select {
                        margin-top: 10px;
                    }
                }

                .preview-info {
                    height: calc(100% - 0px);
                    overflow: hidden;

                    &.portrit-selector {
                        height: calc(100% - 10px - 80px);
                        padding-top: 10px;
                    }

                    .preview-scrollbar {
                        max-height: unset;
                    }
                }

                .titl {
                    text-align: center;
                    color: $main-dark;
                    min-height: rem(35px);
                    display: inline-block;
                    @include font-size(24px);
                    width: 100%;
                    padding: 0px;
                    margin: 0px;
                    font-family: $text-sbold;
                    height: fit-content;
                    line-height: inherit;
                }

                .print_date {
                    min-height: unset;

                    .section {
                        @include border-radius(4px);
                        @include display-flex();
                        @include justify-content(space-between);
                        @include align-items(center);
                        width: 100%;
                        background-color: #fff;
                        padding: 10px 15px;
                        margin: 10px 0;

                        .meta {
                            width: 60%;

                            .label {
                                @include font-size(s);
                                font-family: $text-light;
                                color: $neutro-s70;
                            }

                            .value {
                                @include font-size(s);
                                font-family: $text-bold;
                                text-decoration: none;
                                cursor: default;
                            }
                        }

                        .action {
                            @include text-ellipsis();
                            @include display-flex();
                            @include justify-content(center);
                            @include align-items(center);
                            @include border-radius(4px);
                            @include font-size(sm);
                            font-family: $text-bold;
                            background-color: $neutro;
                            color: $main;
                            width: 40%;
                            text-align: center;
                            height: 50px;
                            cursor: pointer;
                        }
                    }

                    .section.date {
                        padding: 0;
                        background-color: transparent;

                        .modify_date {
                            @include font-size(s);
                            font-family: $text-bold;
                            background-size: 16px;
                            padding-left: 22px;
                            color: $warning-s20;
                        }
                    }
                }

                .portrait-footer {
                    @include display-flex();
                    @include justify-content(flex-end);
                    @include align-items(center);
                    width: calc(100% - 26px);
                    margin: 0 auto;
                    height: 50px;
                    position: absolute;
                    bottom: 19px;

                    .act {
                        @include border-radius(4px);
                        padding: 12.5px 35px;
                        font-family: $text-bold;
                        height: 50px;

                        &.cancel {
                            background-color: #e3e7ed;
                            color: $main;
                        }

                        &.save {
                            background-color: $main-dark;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
}
</style>
